@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package crashbit_multiplatform.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.StringResource

private object CommonMainString0 {
  public val app_name: StringResource by 
      lazy { init_app_name() }

  public val arrow_tutorial_hint: StringResource by 
      lazy { init_arrow_tutorial_hint() }

  public val badge_panned_recenter: StringResource by 
      lazy { init_badge_panned_recenter() }

  public val badge_zoomed_info: StringResource by 
      lazy { init_badge_zoomed_info() }

  public val btn_advanced: StringResource by 
      lazy { init_btn_advanced() }

  public val btn_back_to_command: StringResource by 
      lazy { init_btn_back_to_command() }

  public val btn_cancel_rewind: StringResource by 
      lazy { init_btn_cancel_rewind() }

  public val btn_change_language: StringResource by 
      lazy { init_btn_change_language() }

  public val btn_changelog: StringResource by 
      lazy { init_btn_changelog() }

  public val btn_confirm_rewind: StringResource by 
      lazy { init_btn_confirm_rewind() }

  public val btn_exit_fullscreen: StringResource by 
      lazy { init_btn_exit_fullscreen() }

  public val btn_exit_surface_view: StringResource by 
      lazy { init_btn_exit_surface_view() }

  public val btn_fast_travel_tree: StringResource by 
      lazy { init_btn_fast_travel_tree() }

  public val btn_fullscreen: StringResource by 
      lazy { init_btn_fullscreen() }

  public val btn_how_to_play: StringResource by 
      lazy { init_btn_how_to_play() }

  public val btn_lock_camera: StringResource by 
      lazy { init_btn_lock_camera() }

  public val btn_menu: StringResource by 
      lazy { init_btn_menu() }

  public val btn_open_browser: StringResource by 
      lazy { init_btn_open_browser() }

  public val btn_recenter_view: StringResource by 
      lazy { init_btn_recenter_view() }

  public val btn_release_lock: StringResource by 
      lazy { init_btn_release_lock() }

  public val btn_reset_defaults: StringResource by 
      lazy { init_btn_reset_defaults() }

  public val btn_resume_session: StringResource by 
      lazy { init_btn_resume_session() }

  public val btn_return_to_command: StringResource by 
      lazy { init_btn_return_to_command() }

  public val btn_save: StringResource by 
      lazy { init_btn_save() }

  public val btn_save_confirm: StringResource by 
      lazy { init_btn_save_confirm() }

  public val btn_start_placement: StringResource by 
      lazy { init_btn_start_placement() }

  public val btn_surface_view: StringResource by 
      lazy { init_btn_surface_view() }

  public val btn_tutorial: StringResource by 
      lazy { init_btn_tutorial() }

  public val btn_watch_gameplay: StringResource by 
      lazy { init_btn_watch_gameplay() }

  public val btn_web_upsell: StringResource by 
      lazy { init_btn_web_upsell() }

  public val chem_carbon: StringResource by 
      lazy { init_chem_carbon() }

  public val chem_dark_matter: StringResource by 
      lazy { init_chem_dark_matter() }

  public val chem_helium: StringResource by 
      lazy { init_chem_helium() }

  public val chem_hydrogen: StringResource by 
      lazy { init_chem_hydrogen() }

  public val chem_iron: StringResource by 
      lazy { init_chem_iron() }

  public val chem_metals: StringResource by 
      lazy { init_chem_metals() }

  public val chem_silicates: StringResource by 
      lazy { init_chem_silicates() }

  public val chem_water: StringResource by 
      lazy { init_chem_water() }

  public val cmd_desc_nav: StringResource by 
      lazy { init_cmd_desc_nav() }

  public val cmd_desc_rain: StringResource by 
      lazy { init_cmd_desc_rain() }

  public val cmd_desc_yeeting: StringResource by 
      lazy { init_cmd_desc_yeeting() }

  public val cmd_title_nav: StringResource by 
      lazy { init_cmd_title_nav() }

  public val cmd_title_rain: StringResource by 
      lazy { init_cmd_title_rain() }

  public val cmd_title_yeeting: StringResource by 
      lazy { init_cmd_title_yeeting() }

  public val credit_farrell_observatory: StringResource by 
      lazy { init_credit_farrell_observatory() }

  public val data_habitability: StringResource by 
      lazy { init_data_habitability() }

  public val data_mass: StringResource by 
      lazy { init_data_mass() }

  public val data_radius: StringResource by 
      lazy { init_data_radius() }

  public val data_stability: StringResource by 
      lazy { init_data_stability() }

  public val data_technosignatures: StringResource by 
      lazy { init_data_technosignatures() }

  public val data_temp: StringResource by 
      lazy { init_data_temp() }

  public val desc_photosensitivity: StringResource by 
      lazy { init_desc_photosensitivity() }

  public val format_passes: StringResource by 
      lazy { init_format_passes() }

  public val format_saved_date: StringResource by 
      lazy { init_format_saved_date() }

  public val game_manual_version: StringResource by 
      lazy { init_game_manual_version() }

  public val header_advanced_observation: StringResource by 
      lazy { init_header_advanced_observation() }

  public val header_choosing_path: StringResource by 
      lazy { init_header_choosing_path() }

  public val header_command_intel: StringResource by 
      lazy { init_header_command_intel() }

  public val header_contact_feedback: StringResource by 
      lazy { init_header_contact_feedback() }

  public val header_core_missions: StringResource by 
      lazy { init_header_core_missions() }

  public val header_cosmic_lab: StringResource by 
      lazy { init_header_cosmic_lab() }

  public val header_crazy_eddie_settings: StringResource by 
      lazy { init_header_crazy_eddie_settings() }

  public val header_feedback_settings: StringResource by 
      lazy { init_header_feedback_settings() }

  public val header_galactic_phenomena: StringResource by 
      lazy { init_header_galactic_phenomena() }

  public val header_global_physics: StringResource by 
      lazy { init_header_global_physics() }

  public val header_health_safety: StringResource by 
      lazy { init_header_health_safety() }

  public val header_interstellar_command: StringResource by 
      lazy { init_header_interstellar_command() }

  public val header_mission_control: StringResource by 
      lazy { init_header_mission_control() }

  public val header_physics_fidgeting: StringResource by 
      lazy { init_header_physics_fidgeting() }

  public val header_quick_start: StringResource by 
      lazy { init_header_quick_start() }

  public val header_time_mastery: StringResource by 
      lazy { init_header_time_mastery() }

  public val header_time_mastery_manual: StringResource by 
      lazy { init_header_time_mastery_manual() }

  public val intro_text: StringResource by 
      lazy { init_intro_text() }

  public val lab_desc_options: StringResource by 
      lazy { init_lab_desc_options() }

  public val lab_desc_perf: StringResource by 
      lazy { init_lab_desc_perf() }

  public val lab_title_options: StringResource by 
      lazy { init_lab_title_options() }

  public val lab_title_perf: StringResource by 
      lazy { init_lab_title_perf() }

  public val label_accreting_nebula: StringResource by 
      lazy { init_label_accreting_nebula() }

  public val label_biology_speed: StringResource by 
      lazy { init_label_biology_speed() }

  public val label_boomerang_limit: StringResource by 
      lazy { init_label_boomerang_limit() }

  public val label_camera_follow: StringResource by 
      lazy { init_label_camera_follow() }

  public val label_camera_locked: StringResource by 
      lazy { init_label_camera_locked() }

  public val label_cloud_backup: StringResource by 
      lazy { init_label_cloud_backup() }

  public val label_contact_email: StringResource by 
      lazy { init_label_contact_email() }

  public val label_contact_questions: StringResource by 
      lazy { init_label_contact_questions() }

  public val label_deterministic_physics: StringResource by 
      lazy { init_label_deterministic_physics() }

  public val label_dont_ask_again: StringResource by 
      lazy { init_label_dont_ask_again() }

  public val label_enable_haptics: StringResource by 
      lazy { init_label_enable_haptics() }

  public val label_enable_rewind: StringResource by 
      lazy { init_label_enable_rewind() }

  public val label_gentle: StringResource by 
      lazy { init_label_gentle() }

  public val label_intensity: StringResource by 
      lazy { init_label_intensity() }

  public val label_jordy_population: StringResource by 
      lazy { init_label_jordy_population() }

  public val label_medium: StringResource by 
      lazy { init_label_medium() }

  public val label_merger_pass_limit: StringResource by 
      lazy { init_label_merger_pass_limit() }

  public val label_no_saved_data: StringResource by 
      lazy { init_label_no_saved_data() }

  public val label_no_saved_universes: StringResource by 
      lazy { init_label_no_saved_universes() }

  public val label_photosensitivity_short: StringResource by 
      lazy { init_label_photosensitivity_short() }

  public val label_placement_mode: StringResource by 
      lazy { init_label_placement_mode() }

  public val label_rewind_confirm: StringResource by 
      lazy { init_label_rewind_confirm() }

  public val label_show_performance: StringResource by 
      lazy { init_label_show_performance() }

  public val label_stark: StringResource by 
      lazy { init_label_stark() }

  public val label_stars_consume_planets: StringResource by 
      lazy { init_label_stars_consume_planets() }

  public val label_stars_dynamic: StringResource by 
      lazy { init_label_stars_dynamic() }

  public val label_stars_merge: StringResource by 
      lazy { init_label_stars_merge() }

  public val label_surface_view: StringResource by 
      lazy { init_label_surface_view() }

  public val label_technosignatures_detected: StringResource by 
      lazy { init_label_technosignatures_detected() }

  public val mode_crazy_eddie: StringResource by 
      lazy { init_mode_crazy_eddie() }

  public val mode_dual_star: StringResource by 
      lazy { init_mode_dual_star() }

  public val mode_move: StringResource by 
      lazy { init_mode_move() }

  public val mode_rain: StringResource by 
      lazy { init_mode_rain() }

  public val mode_single_star: StringResource by 
      lazy { init_mode_single_star() }

  public val mode_slingshot: StringResource by 
      lazy { init_mode_slingshot() }

  public val msg_fullscreen_hint: StringResource by 
      lazy { init_msg_fullscreen_hint() }

  public val msg_jordy_extinction: StringResource by 
      lazy { init_msg_jordy_extinction() }

  public val msg_web_upsell: StringResource by 
      lazy { init_msg_web_upsell() }

  public val name_debris: StringResource by 
      lazy { init_name_debris() }

  public val name_fragment: StringResource by 
      lazy { init_name_fragment() }

  public val name_nebula: StringResource by 
      lazy { init_name_nebula() }

  public val name_planet: StringResource by 
      lazy { init_name_planet() }

  public val name_proto_star: StringResource by 
      lazy { init_name_proto_star() }

  public val name_singularity: StringResource by 
      lazy { init_name_singularity() }

  public val obs_desc_camera: StringResource by 
      lazy { init_obs_desc_camera() }

  public val obs_desc_farrell: StringResource by 
      lazy { init_obs_desc_farrell() }

  public val obs_desc_fast_travel: StringResource by 
      lazy { init_obs_desc_fast_travel() }

  public val obs_desc_oracle: StringResource by 
      lazy { init_obs_desc_oracle() }

  public val obs_desc_scanner: StringResource by 
      lazy { init_obs_desc_scanner() }

  public val obs_title_camera: StringResource by 
      lazy { init_obs_title_camera() }

  public val obs_title_farrell: StringResource by 
      lazy { init_obs_title_farrell() }

  public val obs_title_fast_travel: StringResource by 
      lazy { init_obs_title_fast_travel() }

  public val obs_title_oracle: StringResource by 
      lazy { init_obs_title_oracle() }

  public val obs_title_scanner: StringResource by 
      lazy { init_obs_title_scanner() }

  public val path_desc_chaos: StringResource by 
      lazy { init_path_desc_chaos() }

  public val path_title_chaos: StringResource by 
      lazy { init_path_title_chaos() }

  public val phen_desc_evolution: StringResource by 
      lazy { init_phen_desc_evolution() }

  public val phen_desc_jordys: StringResource by 
      lazy { init_phen_desc_jordys() }

  public val phen_desc_nebulae: StringResource by 
      lazy { init_phen_desc_nebulae() }

  public val phen_desc_wormholes: StringResource by 
      lazy { init_phen_desc_wormholes() }

  public val phen_title_evolution: StringResource by 
      lazy { init_phen_title_evolution() }

  public val phen_title_jordys: StringResource by 
      lazy { init_phen_title_jordys() }

  public val phen_title_nebulae: StringResource by 
      lazy { init_phen_title_nebulae() }

  public val phen_title_wormholes: StringResource by 
      lazy { init_phen_title_wormholes() }

  public val phys_desc_barycenter: StringResource by 
      lazy { init_phys_desc_barycenter() }

  public val phys_desc_gscaling: StringResource by 
      lazy { init_phys_desc_gscaling() }

  public val phys_desc_science: StringResource by 
      lazy { init_phys_desc_science() }

  public val phys_desc_tweaks: StringResource by 
      lazy { init_phys_desc_tweaks() }

  public val phys_desc_wells: StringResource by 
      lazy { init_phys_desc_wells() }

  public val phys_title_barycenter: StringResource by 
      lazy { init_phys_title_barycenter() }

  public val phys_title_gscaling: StringResource by 
      lazy { init_phys_title_gscaling() }

  public val phys_title_science: StringResource by 
      lazy { init_phys_title_science() }

  public val phys_title_tweaks: StringResource by 
      lazy { init_phys_title_tweaks() }

  public val phys_title_wells: StringResource by 
      lazy { init_phys_title_wells() }

  public val qs_desc_canvas: StringResource by 
      lazy { init_qs_desc_canvas() }

  public val qs_desc_inspect: StringResource by 
      lazy { init_qs_desc_inspect() }

  public val qs_desc_rain: StringResource by 
      lazy { init_qs_desc_rain() }

  public val qs_desc_yeet: StringResource by 
      lazy { init_qs_desc_yeet() }

  public val qs_title_canvas: StringResource by 
      lazy { init_qs_title_canvas() }

  public val qs_title_inspect: StringResource by 
      lazy { init_qs_title_inspect() }

  public val qs_title_rain: StringResource by 
      lazy { init_qs_title_rain() }

  public val qs_title_yeet: StringResource by 
      lazy { init_qs_title_yeet() }

  public val stat_bh: StringResource by 
      lazy { init_stat_bh() }

  public val stat_fps: StringResource by 
      lazy { init_stat_fps() }

  public val stat_heaviest: StringResource by 
      lazy { init_stat_heaviest() }

  public val stat_planets: StringResource by 
      lazy { init_stat_planets() }

  public val stat_speed: StringResource by 
      lazy { init_stat_speed() }

  public val stat_stars: StringResource by 
      lazy { init_stat_stars() }

  public val stat_system: StringResource by 
      lazy { init_stat_system() }

  public val stat_tps: StringResource by 
      lazy { init_stat_tps() }

  public val tab_chemicals: StringResource by 
      lazy { init_tab_chemicals() }

  public val tab_scanner: StringResource by 
      lazy { init_tab_scanner() }

  public val title_advanced_config: StringResource by 
      lazy { init_title_advanced_config() }

  public val title_changelog: StringResource by 
      lazy { init_title_changelog() }

  public val title_photosensitivity: StringResource by 
      lazy { init_title_photosensitivity() }

  public val title_rewind_dialog: StringResource by 
      lazy { init_title_rewind_dialog() }

  public val title_save_universe: StringResource by 
      lazy { init_title_save_universe() }

  public val title_universe_browser: StringResource by 
      lazy { init_title_universe_browser() }

  public val title_web_upsell: StringResource by 
      lazy { init_title_web_upsell() }

  public val tm_desc_dilation: StringResource by 
      lazy { init_tm_desc_dilation() }

  public val tm_desc_rewind: StringResource by 
      lazy { init_tm_desc_rewind() }

  public val tm_title_dilation: StringResource by 
      lazy { init_tm_title_dilation() }

  public val tm_title_rewind: StringResource by 
      lazy { init_tm_title_rewind() }

  public val tutorial_btn_finish: StringResource by 
      lazy { init_tutorial_btn_finish() }

  public val tutorial_btn_next: StringResource by 
      lazy { init_tutorial_btn_next() }

  public val tutorial_btn_skip: StringResource by 
      lazy { init_tutorial_btn_skip() }

  public val tutorial_step1_desc: StringResource by 
      lazy { init_tutorial_step1_desc() }

  public val tutorial_step1_desc_web: StringResource by 
      lazy { init_tutorial_step1_desc_web() }

  public val tutorial_step1_title: StringResource by 
      lazy { init_tutorial_step1_title() }

  public val tutorial_step2_desc: StringResource by 
      lazy { init_tutorial_step2_desc() }

  public val tutorial_step2_title: StringResource by 
      lazy { init_tutorial_step2_title() }

  public val tutorial_step3_desc: StringResource by 
      lazy { init_tutorial_step3_desc() }

  public val tutorial_step3_title: StringResource by 
      lazy { init_tutorial_step3_title() }

  public val tutorial_step4_desc: StringResource by 
      lazy { init_tutorial_step4_desc() }

  public val tutorial_step4_title: StringResource by 
      lazy { init_tutorial_step4_title() }

  public val tutorial_step5_desc: StringResource by 
      lazy { init_tutorial_step5_desc() }

  public val tutorial_step5_title: StringResource by 
      lazy { init_tutorial_step5_title() }

  public val tutorial_title: StringResource by 
      lazy { init_tutorial_title() }

  public val type_nebula: StringResource by 
      lazy { init_type_nebula() }

  public val type_planetary_body: StringResource by 
      lazy { init_type_planetary_body() }

  public val type_singularity: StringResource by 
      lazy { init_type_singularity() }

  public val type_star: StringResource by 
      lazy { init_type_star() }

  public val type_stellar_object: StringResource by 
      lazy { init_type_stellar_object() }

  public val type_wormhole: StringResource by 
      lazy { init_type_wormhole() }

  public val version_edition: StringResource by 
      lazy { init_version_edition() }
}

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("app_name", CommonMainString0.app_name)
  map.put("arrow_tutorial_hint", CommonMainString0.arrow_tutorial_hint)
  map.put("badge_panned_recenter", CommonMainString0.badge_panned_recenter)
  map.put("badge_zoomed_info", CommonMainString0.badge_zoomed_info)
  map.put("btn_advanced", CommonMainString0.btn_advanced)
  map.put("btn_back_to_command", CommonMainString0.btn_back_to_command)
  map.put("btn_cancel_rewind", CommonMainString0.btn_cancel_rewind)
  map.put("btn_change_language", CommonMainString0.btn_change_language)
  map.put("btn_changelog", CommonMainString0.btn_changelog)
  map.put("btn_confirm_rewind", CommonMainString0.btn_confirm_rewind)
  map.put("btn_exit_fullscreen", CommonMainString0.btn_exit_fullscreen)
  map.put("btn_exit_surface_view", CommonMainString0.btn_exit_surface_view)
  map.put("btn_fast_travel_tree", CommonMainString0.btn_fast_travel_tree)
  map.put("btn_fullscreen", CommonMainString0.btn_fullscreen)
  map.put("btn_how_to_play", CommonMainString0.btn_how_to_play)
  map.put("btn_lock_camera", CommonMainString0.btn_lock_camera)
  map.put("btn_menu", CommonMainString0.btn_menu)
  map.put("btn_open_browser", CommonMainString0.btn_open_browser)
  map.put("btn_recenter_view", CommonMainString0.btn_recenter_view)
  map.put("btn_release_lock", CommonMainString0.btn_release_lock)
  map.put("btn_reset_defaults", CommonMainString0.btn_reset_defaults)
  map.put("btn_resume_session", CommonMainString0.btn_resume_session)
  map.put("btn_return_to_command", CommonMainString0.btn_return_to_command)
  map.put("btn_save", CommonMainString0.btn_save)
  map.put("btn_save_confirm", CommonMainString0.btn_save_confirm)
  map.put("btn_start_placement", CommonMainString0.btn_start_placement)
  map.put("btn_surface_view", CommonMainString0.btn_surface_view)
  map.put("btn_tutorial", CommonMainString0.btn_tutorial)
  map.put("btn_watch_gameplay", CommonMainString0.btn_watch_gameplay)
  map.put("btn_web_upsell", CommonMainString0.btn_web_upsell)
  map.put("chem_carbon", CommonMainString0.chem_carbon)
  map.put("chem_dark_matter", CommonMainString0.chem_dark_matter)
  map.put("chem_helium", CommonMainString0.chem_helium)
  map.put("chem_hydrogen", CommonMainString0.chem_hydrogen)
  map.put("chem_iron", CommonMainString0.chem_iron)
  map.put("chem_metals", CommonMainString0.chem_metals)
  map.put("chem_silicates", CommonMainString0.chem_silicates)
  map.put("chem_water", CommonMainString0.chem_water)
  map.put("cmd_desc_nav", CommonMainString0.cmd_desc_nav)
  map.put("cmd_desc_rain", CommonMainString0.cmd_desc_rain)
  map.put("cmd_desc_yeeting", CommonMainString0.cmd_desc_yeeting)
  map.put("cmd_title_nav", CommonMainString0.cmd_title_nav)
  map.put("cmd_title_rain", CommonMainString0.cmd_title_rain)
  map.put("cmd_title_yeeting", CommonMainString0.cmd_title_yeeting)
  map.put("credit_farrell_observatory", CommonMainString0.credit_farrell_observatory)
  map.put("data_habitability", CommonMainString0.data_habitability)
  map.put("data_mass", CommonMainString0.data_mass)
  map.put("data_radius", CommonMainString0.data_radius)
  map.put("data_stability", CommonMainString0.data_stability)
  map.put("data_technosignatures", CommonMainString0.data_technosignatures)
  map.put("data_temp", CommonMainString0.data_temp)
  map.put("desc_photosensitivity", CommonMainString0.desc_photosensitivity)
  map.put("format_passes", CommonMainString0.format_passes)
  map.put("format_saved_date", CommonMainString0.format_saved_date)
  map.put("game_manual_version", CommonMainString0.game_manual_version)
  map.put("header_advanced_observation", CommonMainString0.header_advanced_observation)
  map.put("header_choosing_path", CommonMainString0.header_choosing_path)
  map.put("header_command_intel", CommonMainString0.header_command_intel)
  map.put("header_contact_feedback", CommonMainString0.header_contact_feedback)
  map.put("header_core_missions", CommonMainString0.header_core_missions)
  map.put("header_cosmic_lab", CommonMainString0.header_cosmic_lab)
  map.put("header_crazy_eddie_settings", CommonMainString0.header_crazy_eddie_settings)
  map.put("header_feedback_settings", CommonMainString0.header_feedback_settings)
  map.put("header_galactic_phenomena", CommonMainString0.header_galactic_phenomena)
  map.put("header_global_physics", CommonMainString0.header_global_physics)
  map.put("header_health_safety", CommonMainString0.header_health_safety)
  map.put("header_interstellar_command", CommonMainString0.header_interstellar_command)
  map.put("header_mission_control", CommonMainString0.header_mission_control)
  map.put("header_physics_fidgeting", CommonMainString0.header_physics_fidgeting)
  map.put("header_quick_start", CommonMainString0.header_quick_start)
  map.put("header_time_mastery", CommonMainString0.header_time_mastery)
  map.put("header_time_mastery_manual", CommonMainString0.header_time_mastery_manual)
  map.put("intro_text", CommonMainString0.intro_text)
  map.put("lab_desc_options", CommonMainString0.lab_desc_options)
  map.put("lab_desc_perf", CommonMainString0.lab_desc_perf)
  map.put("lab_title_options", CommonMainString0.lab_title_options)
  map.put("lab_title_perf", CommonMainString0.lab_title_perf)
  map.put("label_accreting_nebula", CommonMainString0.label_accreting_nebula)
  map.put("label_biology_speed", CommonMainString0.label_biology_speed)
  map.put("label_boomerang_limit", CommonMainString0.label_boomerang_limit)
  map.put("label_camera_follow", CommonMainString0.label_camera_follow)
  map.put("label_camera_locked", CommonMainString0.label_camera_locked)
  map.put("label_cloud_backup", CommonMainString0.label_cloud_backup)
  map.put("label_contact_email", CommonMainString0.label_contact_email)
  map.put("label_contact_questions", CommonMainString0.label_contact_questions)
  map.put("label_deterministic_physics", CommonMainString0.label_deterministic_physics)
  map.put("label_dont_ask_again", CommonMainString0.label_dont_ask_again)
  map.put("label_enable_haptics", CommonMainString0.label_enable_haptics)
  map.put("label_enable_rewind", CommonMainString0.label_enable_rewind)
  map.put("label_gentle", CommonMainString0.label_gentle)
  map.put("label_intensity", CommonMainString0.label_intensity)
  map.put("label_jordy_population", CommonMainString0.label_jordy_population)
  map.put("label_medium", CommonMainString0.label_medium)
  map.put("label_merger_pass_limit", CommonMainString0.label_merger_pass_limit)
  map.put("label_no_saved_data", CommonMainString0.label_no_saved_data)
  map.put("label_no_saved_universes", CommonMainString0.label_no_saved_universes)
  map.put("label_photosensitivity_short", CommonMainString0.label_photosensitivity_short)
  map.put("label_placement_mode", CommonMainString0.label_placement_mode)
  map.put("label_rewind_confirm", CommonMainString0.label_rewind_confirm)
  map.put("label_show_performance", CommonMainString0.label_show_performance)
  map.put("label_stark", CommonMainString0.label_stark)
  map.put("label_stars_consume_planets", CommonMainString0.label_stars_consume_planets)
  map.put("label_stars_dynamic", CommonMainString0.label_stars_dynamic)
  map.put("label_stars_merge", CommonMainString0.label_stars_merge)
  map.put("label_surface_view", CommonMainString0.label_surface_view)
  map.put("label_technosignatures_detected", CommonMainString0.label_technosignatures_detected)
  map.put("mode_crazy_eddie", CommonMainString0.mode_crazy_eddie)
  map.put("mode_dual_star", CommonMainString0.mode_dual_star)
  map.put("mode_move", CommonMainString0.mode_move)
  map.put("mode_rain", CommonMainString0.mode_rain)
  map.put("mode_single_star", CommonMainString0.mode_single_star)
  map.put("mode_slingshot", CommonMainString0.mode_slingshot)
  map.put("msg_fullscreen_hint", CommonMainString0.msg_fullscreen_hint)
  map.put("msg_jordy_extinction", CommonMainString0.msg_jordy_extinction)
  map.put("msg_web_upsell", CommonMainString0.msg_web_upsell)
  map.put("name_debris", CommonMainString0.name_debris)
  map.put("name_fragment", CommonMainString0.name_fragment)
  map.put("name_nebula", CommonMainString0.name_nebula)
  map.put("name_planet", CommonMainString0.name_planet)
  map.put("name_proto_star", CommonMainString0.name_proto_star)
  map.put("name_singularity", CommonMainString0.name_singularity)
  map.put("obs_desc_camera", CommonMainString0.obs_desc_camera)
  map.put("obs_desc_farrell", CommonMainString0.obs_desc_farrell)
  map.put("obs_desc_fast_travel", CommonMainString0.obs_desc_fast_travel)
  map.put("obs_desc_oracle", CommonMainString0.obs_desc_oracle)
  map.put("obs_desc_scanner", CommonMainString0.obs_desc_scanner)
  map.put("obs_title_camera", CommonMainString0.obs_title_camera)
  map.put("obs_title_farrell", CommonMainString0.obs_title_farrell)
  map.put("obs_title_fast_travel", CommonMainString0.obs_title_fast_travel)
  map.put("obs_title_oracle", CommonMainString0.obs_title_oracle)
  map.put("obs_title_scanner", CommonMainString0.obs_title_scanner)
  map.put("path_desc_chaos", CommonMainString0.path_desc_chaos)
  map.put("path_title_chaos", CommonMainString0.path_title_chaos)
  map.put("phen_desc_evolution", CommonMainString0.phen_desc_evolution)
  map.put("phen_desc_jordys", CommonMainString0.phen_desc_jordys)
  map.put("phen_desc_nebulae", CommonMainString0.phen_desc_nebulae)
  map.put("phen_desc_wormholes", CommonMainString0.phen_desc_wormholes)
  map.put("phen_title_evolution", CommonMainString0.phen_title_evolution)
  map.put("phen_title_jordys", CommonMainString0.phen_title_jordys)
  map.put("phen_title_nebulae", CommonMainString0.phen_title_nebulae)
  map.put("phen_title_wormholes", CommonMainString0.phen_title_wormholes)
  map.put("phys_desc_barycenter", CommonMainString0.phys_desc_barycenter)
  map.put("phys_desc_gscaling", CommonMainString0.phys_desc_gscaling)
  map.put("phys_desc_science", CommonMainString0.phys_desc_science)
  map.put("phys_desc_tweaks", CommonMainString0.phys_desc_tweaks)
  map.put("phys_desc_wells", CommonMainString0.phys_desc_wells)
  map.put("phys_title_barycenter", CommonMainString0.phys_title_barycenter)
  map.put("phys_title_gscaling", CommonMainString0.phys_title_gscaling)
  map.put("phys_title_science", CommonMainString0.phys_title_science)
  map.put("phys_title_tweaks", CommonMainString0.phys_title_tweaks)
  map.put("phys_title_wells", CommonMainString0.phys_title_wells)
  map.put("qs_desc_canvas", CommonMainString0.qs_desc_canvas)
  map.put("qs_desc_inspect", CommonMainString0.qs_desc_inspect)
  map.put("qs_desc_rain", CommonMainString0.qs_desc_rain)
  map.put("qs_desc_yeet", CommonMainString0.qs_desc_yeet)
  map.put("qs_title_canvas", CommonMainString0.qs_title_canvas)
  map.put("qs_title_inspect", CommonMainString0.qs_title_inspect)
  map.put("qs_title_rain", CommonMainString0.qs_title_rain)
  map.put("qs_title_yeet", CommonMainString0.qs_title_yeet)
  map.put("stat_bh", CommonMainString0.stat_bh)
  map.put("stat_fps", CommonMainString0.stat_fps)
  map.put("stat_heaviest", CommonMainString0.stat_heaviest)
  map.put("stat_planets", CommonMainString0.stat_planets)
  map.put("stat_speed", CommonMainString0.stat_speed)
  map.put("stat_stars", CommonMainString0.stat_stars)
  map.put("stat_system", CommonMainString0.stat_system)
  map.put("stat_tps", CommonMainString0.stat_tps)
  map.put("tab_chemicals", CommonMainString0.tab_chemicals)
  map.put("tab_scanner", CommonMainString0.tab_scanner)
  map.put("title_advanced_config", CommonMainString0.title_advanced_config)
  map.put("title_changelog", CommonMainString0.title_changelog)
  map.put("title_photosensitivity", CommonMainString0.title_photosensitivity)
  map.put("title_rewind_dialog", CommonMainString0.title_rewind_dialog)
  map.put("title_save_universe", CommonMainString0.title_save_universe)
  map.put("title_universe_browser", CommonMainString0.title_universe_browser)
  map.put("title_web_upsell", CommonMainString0.title_web_upsell)
  map.put("tm_desc_dilation", CommonMainString0.tm_desc_dilation)
  map.put("tm_desc_rewind", CommonMainString0.tm_desc_rewind)
  map.put("tm_title_dilation", CommonMainString0.tm_title_dilation)
  map.put("tm_title_rewind", CommonMainString0.tm_title_rewind)
  map.put("tutorial_btn_finish", CommonMainString0.tutorial_btn_finish)
  map.put("tutorial_btn_next", CommonMainString0.tutorial_btn_next)
  map.put("tutorial_btn_skip", CommonMainString0.tutorial_btn_skip)
  map.put("tutorial_step1_desc", CommonMainString0.tutorial_step1_desc)
  map.put("tutorial_step1_desc_web", CommonMainString0.tutorial_step1_desc_web)
  map.put("tutorial_step1_title", CommonMainString0.tutorial_step1_title)
  map.put("tutorial_step2_desc", CommonMainString0.tutorial_step2_desc)
  map.put("tutorial_step2_title", CommonMainString0.tutorial_step2_title)
  map.put("tutorial_step3_desc", CommonMainString0.tutorial_step3_desc)
  map.put("tutorial_step3_title", CommonMainString0.tutorial_step3_title)
  map.put("tutorial_step4_desc", CommonMainString0.tutorial_step4_desc)
  map.put("tutorial_step4_title", CommonMainString0.tutorial_step4_title)
  map.put("tutorial_step5_desc", CommonMainString0.tutorial_step5_desc)
  map.put("tutorial_step5_title", CommonMainString0.tutorial_step5_title)
  map.put("tutorial_title", CommonMainString0.tutorial_title)
  map.put("type_nebula", CommonMainString0.type_nebula)
  map.put("type_planetary_body", CommonMainString0.type_planetary_body)
  map.put("type_singularity", CommonMainString0.type_singularity)
  map.put("type_star", CommonMainString0.type_star)
  map.put("type_stellar_object", CommonMainString0.type_stellar_object)
  map.put("type_wormhole", CommonMainString0.type_wormhole)
  map.put("version_edition", CommonMainString0.version_edition)
}

internal val Res.string.app_name: StringResource
  get() = CommonMainString0.app_name

private fun init_app_name(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:app_name", "app_name",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    10, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    10, 28),
    )
)

internal val Res.string.arrow_tutorial_hint: StringResource
  get() = CommonMainString0.arrow_tutorial_hint

private fun init_arrow_tutorial_hint(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:arrow_tutorial_hint", "arrow_tutorial_hint",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    39, 43),
    )
)

internal val Res.string.badge_panned_recenter: StringResource
  get() = CommonMainString0.badge_panned_recenter

private fun init_badge_panned_recenter(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:badge_panned_recenter", "badge_panned_recenter",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    83, 105),
    )
)

internal val Res.string.badge_zoomed_info: StringResource
  get() = CommonMainString0.badge_zoomed_info

private fun init_badge_zoomed_info(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:badge_zoomed_info", "badge_zoomed_info",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    189, 101),
    )
)

internal val Res.string.btn_advanced: StringResource
  get() = CommonMainString0.btn_advanced

private fun init_btn_advanced(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:btn_advanced", "btn_advanced",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    39, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    39, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    39, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    39, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    39, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    39, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    39, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    39, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    39, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    39, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    39, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    39, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    39, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    39, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    39, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    291, 32),
    )
)

internal val Res.string.btn_back_to_command: StringResource
  get() = CommonMainString0.btn_back_to_command

private fun init_btn_back_to_command(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_back_to_command", "btn_back_to_command",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    108, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    72, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    72, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    72, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    80, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    72, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    72, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    76, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    80, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    76, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    72, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    84, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    76, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    72, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    76, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    324, 47),
    )
)

internal val Res.string.btn_cancel_rewind: StringResource
  get() = CommonMainString0.btn_cancel_rewind

private fun init_btn_cancel_rewind(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_cancel_rewind", "btn_cancel_rewind",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    196, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    128, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    124, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    132, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    172, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    124, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    124, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    132, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    144, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    132, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    124, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    144, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    124, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    128, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    124, 33),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    372, 33),
    )
)

internal val Res.string.btn_change_language: StringResource
  get() = CommonMainString0.btn_change_language

private fun init_btn_change_language(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_change_language", "btn_change_language",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    242, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    166, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    162, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    170, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    234, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    158, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    162, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    178, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    178, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    166, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    162, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    186, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    158, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    162, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    158, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    406, 47),
    )
)

internal val Res.string.btn_changelog: StringResource
  get() = CommonMainString0.btn_changelog

private fun init_btn_changelog(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:btn_changelog", "btn_changelog",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    454, 33),
    )
)

internal val Res.string.btn_confirm_rewind: StringResource
  get() = CommonMainString0.btn_confirm_rewind

private fun init_btn_confirm_rewind(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_confirm_rewind", "btn_confirm_rewind",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    338, 90),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    214, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    210, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    222, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    302, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    202, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    210, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    222, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    226, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    214, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    210, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    246, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    206, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    222, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    202, 46),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    488, 42),
    )
)

internal val Res.string.btn_exit_fullscreen: StringResource
  get() = CommonMainString0.btn_exit_fullscreen

private fun init_btn_exit_fullscreen(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_exit_fullscreen", "btn_exit_fullscreen",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    531, 55),
    )
)

internal val Res.string.btn_exit_surface_view: StringResource
  get() = CommonMainString0.btn_exit_surface_view

private fun init_btn_exit_surface_view(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_exit_surface_view", "btn_exit_surface_view",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    429, 161),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    261, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    257, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    269, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    389, 133),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    249, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    257, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    277, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    273, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    261, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    257, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    309, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    253, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    273, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    249, 61),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    587, 61),
    )
)

internal val Res.string.btn_fast_travel_tree: StringResource
  get() = CommonMainString0.btn_fast_travel_tree

private fun init_btn_fast_travel_tree(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_fast_travel_tree", "btn_fast_travel_tree",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    591, 140),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    331, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    327, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    343, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    523, 124),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    323, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    331, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    347, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    335, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    331, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    327, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    415, 120),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    323, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    347, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    311, 60),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    649, 64),
    )
)

internal val Res.string.btn_fullscreen: StringResource
  get() = CommonMainString0.btn_fullscreen

private fun init_btn_fullscreen(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:btn_fullscreen", "btn_fullscreen",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    714, 42),
    )
)

internal val Res.string.btn_how_to_play: StringResource
  get() = CommonMainString0.btn_how_to_play

private fun init_btn_how_to_play(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:btn_how_to_play", "btn_how_to_play",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    732, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    396, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    404, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    420, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    648, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    396, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    408, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    440, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    412, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    404, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    404, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    536, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    396, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    432, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    372, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    757, 39),
    )
)

internal val Res.string.btn_lock_camera: StringResource
  get() = CommonMainString0.btn_lock_camera

private fun init_btn_lock_camera(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:btn_lock_camera", "btn_lock_camera",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    808, 115),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    440, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    444, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    464, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    712, 111),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    436, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    448, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    476, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    456, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    440, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    444, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    588, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    440, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    472, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    412, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    797, 51),
    )
)

internal val Res.string.btn_menu: StringResource
  get() = CommonMainString0.btn_menu

private fun init_btn_menu(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:btn_menu", "btn_menu",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    924, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    496, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    508, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    528, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    824, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    492, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    512, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    548, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    516, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    496, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    500, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    680, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    500, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    536, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    464, 24),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    849, 24),
    )
)

internal val Res.string.btn_open_browser: StringResource
  get() = CommonMainString0.btn_open_browser

private fun init_btn_open_browser(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_open_browser", "btn_open_browser",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    957, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    521, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    533, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    553, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    857, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    517, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    537, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    581, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    541, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    521, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    525, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    709, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    525, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    561, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    489, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    874, 40),
    )
)

internal val Res.string.btn_recenter_view: StringResource
  get() = CommonMainString0.btn_recenter_view

private fun init_btn_recenter_view(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_recenter_view", "btn_recenter_view",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    1038, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    566, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    578, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    606, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    938, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    558, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    578, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    634, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    594, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    578, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    570, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    774, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    574, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    614, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    534, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    915, 37),
    )
)

internal val Res.string.btn_release_lock: StringResource
  get() = CommonMainString0.btn_release_lock

private fun init_btn_release_lock(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_release_lock", "btn_release_lock",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    1140, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    612, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    616, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    648, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1032, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    604, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    616, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    680, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    632, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    620, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    608, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    836, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    624, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    664, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    576, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    953, 52),
    )
)

internal val Res.string.btn_reset_defaults: StringResource
  get() = CommonMainString0.btn_reset_defaults

private fun init_btn_reset_defaults(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_reset_defaults", "btn_reset_defaults",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    1225, 110),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    665, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    677, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    709, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1117, 134),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    657, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    677, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    737, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    689, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    677, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    665, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    917, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    681, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    713, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    625, 58),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1006, 58),
    )
)

internal val Res.string.btn_resume_session: StringResource
  get() = CommonMainString0.btn_resume_session

private fun init_btn_resume_session(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_resume_session", "btn_resume_session",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    1336, 114),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    740, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    752, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    788, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1252, 126),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    724, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    744, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    796, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    756, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    748, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    736, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    992, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    740, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    784, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    684, 50),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1065, 54),
    )
)

internal val Res.string.btn_return_to_command: StringResource
  get() = CommonMainString0.btn_return_to_command

private fun init_btn_return_to_command(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_return_to_command", "btn_return_to_command",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    1451, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    791, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    811, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    843, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1379, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    779, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    803, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    855, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    811, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    807, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    791, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1067, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    791, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    859, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    735, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1120, 53),
    )
)

internal val Res.string.btn_save: StringResource
  get() = CommonMainString0.btn_save

private fun init_btn_save(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:btn_save", "btn_save",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    1594, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    886, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    902, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    946, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1522, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    866, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    890, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    946, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    910, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    898, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    878, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1170, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    874, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    950, 24),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    818, 24),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1207, 24),
    )
)

internal val Res.string.btn_save_confirm: StringResource
  get() = CommonMainString0.btn_save_confirm

private fun init_btn_save_confirm(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_save_confirm", "btn_save_confirm",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    1541, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    849, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    865, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    905, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1473, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    833, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    857, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    913, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    877, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    865, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    845, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1137, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    841, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    917, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    785, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1174, 32),
    )
)

internal val Res.string.btn_start_placement: StringResource
  get() = CommonMainString0.btn_start_placement

private fun init_btn_start_placement(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_start_placement", "btn_start_placement",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    1639, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    915, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    931, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    979, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1563, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    891, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    915, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    971, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    935, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    923, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    903, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1211, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    899, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    975, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    843, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1232, 35),
    )
)

internal val Res.string.btn_surface_view: StringResource
  get() = CommonMainString0.btn_surface_view

private fun init_btn_surface_view(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_surface_view", "btn_surface_view",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    1683, 100),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    951, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    971, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1019, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1627, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    927, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    951, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    1007, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    971, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    959, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    943, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1251, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    939, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    1019, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    879, 56),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1268, 56),
    )
)

internal val Res.string.btn_tutorial: StringResource
  get() = CommonMainString0.btn_tutorial

private fun init_btn_tutorial(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:btn_tutorial", "btn_tutorial",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1325, 32),
    )
)

internal val Res.string.btn_watch_gameplay: StringResource
  get() = CommonMainString0.btn_watch_gameplay

private fun init_btn_watch_gameplay(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:btn_watch_gameplay", "btn_watch_gameplay",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1358, 50),
    )
)

internal val Res.string.btn_web_upsell: StringResource
  get() = CommonMainString0.btn_web_upsell

private fun init_btn_web_upsell(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:btn_web_upsell", "btn_web_upsell",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1409, 46),
    )
)

internal val Res.string.chem_carbon: StringResource
  get() = CommonMainString0.chem_carbon

private fun init_chem_carbon(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:chem_carbon", "chem_carbon",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    1784, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1012, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1032, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1080, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1716, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    988, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    1016, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    1072, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    1028, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    1020, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1004, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1348, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    996, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    1096, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    936, 23),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1456, 27),
    )
)

internal val Res.string.chem_dark_matter: StringResource
  get() = CommonMainString0.chem_dark_matter

private fun init_chem_dark_matter(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:chem_dark_matter", "chem_dark_matter",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    1828, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1048, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1064, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1112, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1760, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    1016, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    1048, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    1100, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    1056, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    1052, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1036, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1388, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    1024, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    1124, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    960, 36),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1484, 40),
    )
)

internal val Res.string.chem_helium: StringResource
  get() = CommonMainString0.chem_helium

private fun init_chem_helium(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:chem_helium", "chem_helium",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    1905, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1093, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1109, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1157, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1825, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    1057, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    1093, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    1141, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    1101, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    1097, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1081, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1449, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    1069, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    1173, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    997, 23),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1525, 27),
    )
)

internal val Res.string.chem_hydrogen: StringResource
  get() = CommonMainString0.chem_hydrogen

private fun init_chem_hydrogen(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:chem_hydrogen", "chem_hydrogen",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    1957, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1121, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1137, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1189, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1869, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    1085, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    1121, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    1177, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    1129, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    1121, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1109, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1485, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    1097, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    1201, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1021, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1553, 33),
    )
)

internal val Res.string.chem_iron: StringResource
  get() = CommonMainString0.chem_iron

private fun init_chem_iron(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:chem_iron", "chem_iron",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    2019, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1159, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1175, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1227, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1927, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    1119, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    1155, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    1207, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    1159, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    1151, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1147, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1527, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    1131, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    1231, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1047, 21),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1587, 25),
    )
)

internal val Res.string.chem_metals: StringResource
  get() = CommonMainString0.chem_metals

private fun init_chem_metals(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:chem_metals", "chem_metals",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    2053, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1185, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1201, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1249, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1961, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    1145, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    1181, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    1229, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    1181, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    1181, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1173, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1561, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    1157, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    1257, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1069, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1613, 27),
    )
)

internal val Res.string.chem_silicates: StringResource
  get() = CommonMainString0.chem_silicates

private fun init_chem_silicates(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:chem_silicates", "chem_silicates",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    2089, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1217, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1233, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1281, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    1997, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    1173, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    1213, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    1257, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    1209, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    1209, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1201, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1601, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    1189, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    1293, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1097, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1641, 34),
    )
)

internal val Res.string.chem_water: StringResource
  get() = CommonMainString0.chem_water

private fun init_chem_water(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:chem_water", "chem_water",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    2140, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1252, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1268, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1316, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    2048, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    1208, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    1248, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    1296, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    1244, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    1244, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1236, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1648, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    1228, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    1328, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1132, 22),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1676, 26),
    )
)

internal val Res.string.cmd_desc_nav: StringResource
  get() = CommonMainString0.cmd_desc_nav

private fun init_cmd_desc_nav(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:cmd_desc_nav", "cmd_desc_nav",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    2167, 412),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1279, 224),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1295, 232),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1339, 236),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    2083, 416),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    1231, 232),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    1275, 212),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    1319, 220),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    1267, 292),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    1271, 264),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1263, 236),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    1679, 368),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    1251, 220),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    1359, 252),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1155, 172),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1703, 256),
    )
)

internal val Res.string.cmd_desc_rain: StringResource
  get() = CommonMainString0.cmd_desc_rain

private fun init_cmd_desc_rain(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:cmd_desc_rain", "cmd_desc_rain",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    2580, 341),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1504, 201),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1528, 325),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1576, 373),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    2500, 425),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    1464, 317),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    1488, 281),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    1540, 229),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    1560, 241),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    1536, 341),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1500, 297),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2048, 301),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    1472, 169),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    1612, 405),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1328, 213),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    1960, 401),
    )
)

internal val Res.string.cmd_desc_yeeting: StringResource
  get() = CommonMainString0.cmd_desc_yeeting

private fun init_cmd_desc_yeeting(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:cmd_desc_yeeting", "cmd_desc_yeeting",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    2922, 476),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1706, 264),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    1854, 340),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    1950, 356),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    2926, 688),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    1782, 296),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    1770, 264),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    1770, 308),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    1802, 328),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    1878, 308),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    1798, 288),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2350, 356),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    1642, 304),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    2018, 356),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1542, 236),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    2362, 308),
    )
)

internal val Res.string.cmd_title_nav: StringResource
  get() = CommonMainString0.cmd_title_nav

private fun init_cmd_title_nav(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:cmd_title_nav", "cmd_title_nav",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    3399, 97),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    1971, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2195, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2307, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    3615, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    2079, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    2035, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    2079, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    2131, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    2187, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2087, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2707, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    1947, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    2375, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1779, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    2671, 45),
    )
)

internal val Res.string.cmd_title_rain: StringResource
  get() = CommonMainString0.cmd_title_rain

private fun init_cmd_title_rain(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:cmd_title_rain", "cmd_title_rain",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    3497, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2021, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2241, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2357, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    3705, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    2121, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    2085, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    2153, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    2185, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    2233, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2133, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2773, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    1993, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    2437, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1817, 38),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    2717, 38),
    )
)

internal val Res.string.cmd_title_yeeting: StringResource
  get() = CommonMainString0.cmd_title_yeeting

private fun init_cmd_title_yeeting(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:cmd_title_yeeting", "cmd_title_yeeting",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    3540, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2068, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2284, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2400, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    3772, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    2160, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    2128, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    2212, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    2232, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    2280, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2176, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2840, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    2036, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    2480, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1856, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    2756, 45),
    )
)

internal val Res.string.credit_farrell_observatory: StringResource
  get() = CommonMainString0.credit_farrell_observatory

private fun init_credit_farrell_observatory(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:credit_farrell_observatory", "credit_farrell_observatory",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    3618, 262),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2114, 150),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2330, 146),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2450, 138),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    3878, 246),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    2206, 122),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    2174, 146),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    2258, 150),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    2282, 138),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    2330, 138),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2226, 146),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    2898, 174),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    2094, 134),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    2538, 150),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    1898, 126),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    2802, 142),
    )
)

internal val Res.string.data_habitability: StringResource
  get() = CommonMainString0.data_habitability

private fun init_data_habitability(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:data_habitability", "data_habitability",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    3881, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2265, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2477, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2589, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    4125, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    2329, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    2321, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    2409, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    2421, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    2469, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2373, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3073, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    2229, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    2689, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2025, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    2945, 41),
    )
)

internal val Res.string.data_mass: StringResource
  get() = CommonMainString0.data_mass

private fun init_data_mass(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:data_mass", "data_mass",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    3947, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2311, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2523, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2635, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    4207, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    2375, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    2363, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    2455, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    2471, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    2531, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2419, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3131, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    2275, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    2747, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2063, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    2987, 25),
    )
)

internal val Res.string.data_radius: StringResource
  get() = CommonMainString0.data_radius

private fun init_data_radius(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:data_radius", "data_radius",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    3973, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2337, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2549, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2661, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    4261, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    2401, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    2389, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    2481, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    2497, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    2557, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2445, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3165, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    2301, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    2785, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2089, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    3013, 27),
    )
)

internal val Res.string.data_stability: StringResource
  get() = CommonMainString0.data_stability

private fun init_data_stability(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:data_stability", "data_stability",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    4029, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2365, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2577, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2689, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    4313, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    2429, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    2417, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    2509, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    2529, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    2589, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2473, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3201, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    2333, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    2821, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2117, 34),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    3041, 34),
    )
)

internal val Res.string.data_technosignatures: StringResource
  get() = CommonMainString0.data_technosignatures

private fun init_data_technosignatures(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:data_technosignatures", "data_technosignatures",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    4096, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2404, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2616, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2728, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    4364, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    2468, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    2456, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    2544, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    2564, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    2628, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2512, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3256, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    2372, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    2868, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2152, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    3076, 53),
    )
)

internal val Res.string.data_temp: StringResource
  get() = CommonMainString0.data_temp

private fun init_data_temp(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:data_temp", "data_temp",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    4178, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2458, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2662, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2782, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    4450, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    2518, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    2502, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    2610, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    2622, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    2678, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2566, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3326, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    2422, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    2930, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2198, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    3130, 25),
    )
)

internal val Res.string.desc_photosensitivity: StringResource
  get() = CommonMainString0.desc_photosensitivity

private fun init_desc_photosensitivity(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:desc_photosensitivity", "desc_photosensitivity",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    4232, 829),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    2484, 541),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    2688, 525),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    2808, 617),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    4492, 1109),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    2544, 481),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    2528, 493),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    2636, 645),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    2648, 537),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    2704, 541),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    2592, 501),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    3356, 897),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    2452, 445),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    2968, 677),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2224, 369),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    3156, 453),
    )
)

internal val Res.string.format_passes: StringResource
  get() = CommonMainString0.format_passes

private fun init_format_passes(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:format_passes", "format_passes",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    5062, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3026, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3214, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3426, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    5602, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3026, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3022, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    3282, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3186, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    3246, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3094, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4254, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    2898, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    3646, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2594, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    3610, 37),
    )
)

internal val Res.string.format_saved_date: StringResource
  get() = CommonMainString0.format_saved_date

private fun init_format_saved_date(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:format_saved_date", "format_saved_date",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    5104, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3068, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3248, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3464, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    5644, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3064, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3060, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    3324, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3232, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    3288, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3136, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4304, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    2936, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    3692, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2640, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    3648, 37),
    )
)

internal val Res.string.game_manual_version: StringResource
  get() = CommonMainString0.game_manual_version

private fun init_game_manual_version(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:game_manual_version", "game_manual_version",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    5170, 183),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3114, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3290, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3510, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    5710, 151),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3110, 99),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3102, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    3374, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3282, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    3330, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3174, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4362, 123),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    2974, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    3738, 123),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2690, 83),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    3686, 79),
    )
)

internal val Res.string.header_advanced_observation: StringResource
  get() = CommonMainString0.header_advanced_observation

private fun init_header_advanced_observation(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_advanced_observation", "header_advanced_observation",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    5354, 99),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3222, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3398, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3618, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    5862, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3210, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3210, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    3478, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3378, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    3422, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3278, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4486, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3078, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    3862, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2774, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    3766, 63),
    )
)

internal val Res.string.header_choosing_path: StringResource
  get() = CommonMainString0.header_choosing_path

private fun init_header_choosing_path(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_choosing_path", "header_choosing_path",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    5454, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3290, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3462, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3682, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    5946, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3274, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3274, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    3534, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3434, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    3490, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3346, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4582, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3138, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    3926, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2826, 52),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    3830, 52),
    )
)

internal val Res.string.header_command_intel: StringResource
  get() = CommonMainString0.header_command_intel

private fun init_header_command_intel(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_command_intel", "header_command_intel",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    5543, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3351, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3519, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3739, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    6023, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3327, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3335, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    3583, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3483, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    3543, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3407, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4639, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3191, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    3999, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2879, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    3883, 48),
    )
)

internal val Res.string.header_contact_feedback: StringResource
  get() = CommonMainString0.header_contact_feedback

private fun init_header_contact_feedback(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_contact_feedback", "header_contact_feedback",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    3932, 71),
    )
)

internal val Res.string.header_core_missions: StringResource
  get() = CommonMainString0.header_core_missions

private fun init_header_core_missions(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_core_missions", "header_core_missions",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    5636, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3404, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3580, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3796, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    6104, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3376, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3384, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    3648, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3536, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    3600, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3468, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4728, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3252, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4060, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2928, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4004, 44),
    )
)

internal val Res.string.header_cosmic_lab: StringResource
  get() = CommonMainString0.header_cosmic_lab

private fun init_header_cosmic_lab(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_cosmic_lab", "header_cosmic_lab",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    5721, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3449, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3633, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3849, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    6197, 97),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3425, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3441, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    3705, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3589, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    3649, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3517, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4781, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3301, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4121, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    2973, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4049, 53),
    )
)

internal val Res.string.header_crazy_eddie_settings: StringResource
  get() = CommonMainString0.header_crazy_eddie_settings

private fun init_header_crazy_eddie_settings(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_crazy_eddie_settings", "header_crazy_eddie_settings",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    5811, 111),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3503, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3691, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3907, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    6295, 123),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3479, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3499, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    3763, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3643, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    3707, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3575, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4867, 115),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3351, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4187, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3019, 67),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4103, 71),
    )
)

internal val Res.string.header_feedback_settings: StringResource
  get() = CommonMainString0.header_feedback_settings

private fun init_header_feedback_settings(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_feedback_settings", "header_feedback_settings",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    5923, 132),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3583, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3763, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    3983, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    6419, 128),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3551, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3583, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    3855, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3723, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    3783, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3659, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    4983, 108),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3427, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4271, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3087, 60),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4175, 68),
    )
)

internal val Res.string.header_galactic_phenomena: StringResource
  get() = CommonMainString0.header_galactic_phenomena

private fun init_header_galactic_phenomena(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_galactic_phenomena", "header_galactic_phenomena",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    6056, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3664, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3860, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4080, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    6548, 97),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3632, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3668, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    3952, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3796, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    3864, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3752, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5092, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3512, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4356, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3148, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4244, 57),
    )
)

internal val Res.string.header_global_physics: StringResource
  get() = CommonMainString0.header_global_physics

private fun init_header_global_physics(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_global_physics", "header_global_physics",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    6150, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3730, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3926, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4146, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    6646, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3690, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3726, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    4002, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3850, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    3926, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3818, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5182, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3574, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4426, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3198, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4302, 49),
    )
)

internal val Res.string.header_health_safety: StringResource
  get() = CommonMainString0.header_health_safety

private fun init_header_health_safety(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_health_safety", "header_health_safety",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    6240, 116),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3780, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    3976, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4200, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    6732, 104),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3740, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3776, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    4060, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3912, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    3976, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3868, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5256, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3628, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4484, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3244, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4352, 48),
    )
)

internal val Res.string.header_interstellar_command: StringResource
  get() = CommonMainString0.header_interstellar_command

private fun init_header_interstellar_command(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_interstellar_command", "header_interstellar_command",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    6357, 123),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3845, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4029, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4257, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    6837, 99),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3801, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3829, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    4109, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    3965, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    4041, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3925, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5345, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3685, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4545, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3293, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4401, 63),
    )
)

internal val Res.string.header_mission_control: StringResource
  get() = CommonMainString0.header_mission_control

private fun init_header_mission_control(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_mission_control", "header_mission_control",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    6481, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3913, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4093, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4329, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    6937, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3865, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3893, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    4197, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    4037, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    4113, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    3989, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5441, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3753, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4609, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3345, 46),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4465, 50),
    )
)

internal val Res.string.header_physics_fidgeting: StringResource
  get() = CommonMainString0.header_physics_fidgeting

private fun init_header_physics_fidgeting(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_physics_fidgeting", "header_physics_fidgeting",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    6564, 116),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    3968, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4148, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4388, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    7020, 128),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3912, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    3948, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    4272, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    4092, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    4164, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4048, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5520, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3804, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4680, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3392, 52),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4516, 64),
    )
)

internal val Res.string.header_quick_start: StringResource
  get() = CommonMainString0.header_quick_start

private fun init_header_quick_start(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_quick_start", "header_quick_start",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    6681, 134),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4029, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4221, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4445, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    7149, 134),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    3969, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    4009, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    4345, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    4153, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    4217, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4105, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5581, 110),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3857, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4741, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3445, 70),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4581, 66),
    )
)

internal val Res.string.header_time_mastery: StringResource
  get() = CommonMainString0.header_time_mastery

private fun init_header_time_mastery(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_time_mastery", "header_time_mastery",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    6895, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4163, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4359, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4587, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    7355, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    4099, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    4143, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    4495, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    4287, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    4355, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4243, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5779, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3995, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4895, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3567, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4699, 55),
    )
)

internal val Res.string.header_time_mastery_manual: StringResource
  get() = CommonMainString0.header_time_mastery_manual

private fun init_header_time_mastery_manual(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:header_time_mastery_manual", "header_time_mastery_manual",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    6816, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4104, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4296, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4528, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    7284, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    4040, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    4080, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    4428, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    4224, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    4292, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4184, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5692, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    3936, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4828, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3516, 50),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4648, 50),
    )
)

internal val Res.string.intro_text: StringResource
  get() = CommonMainString0.intro_text

private fun init_intro_text(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:intro_text", "intro_text",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    6991, 1270),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4231, 638),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    4431, 830),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    4659, 698),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    7451, 946),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    4163, 610),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    4215, 634),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    4563, 654),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    4351, 658),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    4427, 750),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    4319, 802),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    5851, 926),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    4055, 626),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    4975, 798),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    3619, 426),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    4755, 710),
    )
)

internal val Res.string.lab_desc_options: StringResource
  get() = CommonMainString0.lab_desc_options

private fun init_lab_desc_options(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:lab_desc_options", "lab_desc_options",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    8262, 460),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    4870, 220),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5262, 292),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5358, 244),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    8398, 452),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    4774, 192),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    4850, 224),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    5218, 204),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    5010, 236),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    5178, 192),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5122, 228),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    6778, 280),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    4682, 212),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    5774, 244),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4046, 160),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    5466, 264),
    )
)

internal val Res.string.lab_desc_perf: StringResource
  get() = CommonMainString0.lab_desc_perf

private fun init_lab_desc_perf(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:lab_desc_perf", "lab_desc_perf",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    8723, 389),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5091, 225),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5555, 269),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5603, 229),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    8851, 385),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    4967, 185),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5075, 221),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    5423, 225),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    5247, 205),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    5371, 173),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5351, 197),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7059, 257),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    4895, 197),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    6019, 257),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4207, 181),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    5731, 261),
    )
)

internal val Res.string.lab_title_options: StringResource
  get() = CommonMainString0.lab_title_options

private fun init_lab_title_options(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:lab_title_options", "lab_title_options",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    9113, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5317, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5825, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5833, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    9237, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5153, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5297, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    5649, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    5453, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    5545, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5549, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7317, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5093, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    6277, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4389, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    5993, 49),
    )
)

internal val Res.string.lab_title_perf: StringResource
  get() = CommonMainString0.lab_title_perf

private fun init_lab_title_perf(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:lab_title_perf", "lab_title_perf",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    9187, 106),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5371, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5875, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5883, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    9311, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5199, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5347, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    5695, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    5499, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    5595, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5603, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7399, 98),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5151, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    6331, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4431, 38),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6043, 54),
    )
)

internal val Res.string.label_accreting_nebula: StringResource
  get() = CommonMainString0.label_accreting_nebula

private fun init_label_accreting_nebula(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_accreting_nebula", "label_accreting_nebula",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    9294, 110),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5422, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5930, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    5946, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    9398, 130),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5246, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5402, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    5766, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    5550, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    5646, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5662, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7498, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5198, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    6386, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4470, 54),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6098, 58),
    )
)

internal val Res.string.label_biology_speed: StringResource
  get() = CommonMainString0.label_biology_speed

private fun init_label_biology_speed(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_biology_speed", "label_biology_speed",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    9405, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5481, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    5993, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6017, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    9529, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5301, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5465, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    5825, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    5605, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    5705, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5721, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7585, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5265, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    6461, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4525, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6157, 47),
    )
)

internal val Res.string.label_boomerang_limit: StringResource
  get() = CommonMainString0.label_boomerang_limit

private fun init_label_boomerang_limit(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_boomerang_limit", "label_boomerang_limit",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    9497, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5545, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6049, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6069, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    9593, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5353, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5521, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    5877, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    5661, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    5761, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5777, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7657, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5313, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    6521, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4577, 49),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6205, 49),
    )
)

internal val Res.string.label_camera_follow: StringResource
  get() = CommonMainString0.label_camera_follow

private fun init_label_camera_follow(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_camera_follow", "label_camera_follow",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    9575, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5595, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6107, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6123, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    9671, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5403, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5575, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    5935, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    5715, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    5811, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5835, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7727, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5367, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    6583, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4627, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6255, 35),
    )
)

internal val Res.string.label_camera_locked: StringResource
  get() = CommonMainString0.label_camera_locked

private fun init_label_camera_locked(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_camera_locked", "label_camera_locked",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    9627, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5631, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6143, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6159, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    9735, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5439, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5611, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    5971, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    5751, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    5851, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5871, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7779, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5407, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    6623, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4663, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6291, 35),
    )
)

internal val Res.string.label_cloud_backup: StringResource
  get() = CommonMainString0.label_cloud_backup

private fun init_label_cloud_backup(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_cloud_backup", "label_cloud_backup",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    9679, 130),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5671, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6183, 94),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6203, 90),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    9807, 118),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5479, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5651, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6011, 98),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    5791, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    5895, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5911, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7843, 134),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5451, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    6667, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4703, 66),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6327, 62),
    )
)

internal val Res.string.label_contact_email: StringResource
  get() = CommonMainString0.label_contact_email

private fun init_label_contact_email(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_contact_email", "label_contact_email",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6390, 63),
    )
)

internal val Res.string.label_contact_questions: StringResource
  get() = CommonMainString0.label_contact_questions

private fun init_label_contact_questions(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_contact_questions", "label_contact_questions",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6454, 79),
    )
)

internal val Res.string.label_deterministic_physics: StringResource
  get() = CommonMainString0.label_deterministic_physics

private fun init_label_deterministic_physics(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_deterministic_physics", "label_deterministic_physics",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    9810, 163),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5750, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6278, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6294, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    9926, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5550, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5722, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6110, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    5870, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    5974, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    5998, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    7978, 131),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5526, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    6746, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4770, 67),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6534, 75),
    )
)

internal val Res.string.label_dont_ask_again: StringResource
  get() = CommonMainString0.label_dont_ask_again

private fun init_label_dont_ask_again(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_dont_ask_again", "label_dont_ask_again",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    9974, 100),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5830, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6354, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6374, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    10030, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5626, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5802, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6182, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    5946, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    6058, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6082, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8110, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5602, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    6834, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4838, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6610, 52),
    )
)

internal val Res.string.label_enable_haptics: StringResource
  get() = CommonMainString0.label_enable_haptics

private fun init_label_enable_haptics(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_enable_haptics", "label_enable_haptics",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    10075, 132),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5887, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6411, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6427, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    10111, 120),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5679, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5855, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6247, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6003, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    6111, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6143, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8191, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5651, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    6903, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4883, 52),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6663, 60),
    )
)

internal val Res.string.label_enable_rewind: StringResource
  get() = CommonMainString0.label_enable_rewind

private fun init_label_enable_rewind(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_enable_rewind", "label_enable_rewind",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    10208, 143),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    5956, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6492, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6492, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    10232, 131),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5744, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5916, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6336, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6068, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    6180, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6208, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8288, 99),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5728, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    6964, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4936, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6724, 59),
    )
)

internal val Res.string.label_gentle: StringResource
  get() = CommonMainString0.label_gentle

private fun init_label_gentle(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:label_gentle", "label_gentle",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    10352, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6028, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6564, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6568, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    10364, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5808, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    5988, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6416, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6132, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    6252, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6280, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8388, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5800, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    7032, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    4988, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6784, 28),
    )
)

internal val Res.string.label_intensity: StringResource
  get() = CommonMainString0.label_intensity

private fun init_label_intensity(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:label_intensity", "label_intensity",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    10389, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6057, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6593, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6597, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    10401, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5837, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6021, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6445, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6161, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    6285, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6309, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8425, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5829, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    7069, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5017, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6813, 35),
    )
)

internal val Res.string.label_jordy_population: StringResource
  get() = CommonMainString0.label_jordy_population

private fun init_label_jordy_population(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_jordy_population", "label_jordy_population",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    10441, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6097, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6633, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6637, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    10453, 90),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5877, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6061, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6477, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6193, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    6329, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6349, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8485, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5865, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    7113, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5049, 46),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6849, 54),
    )
)

internal val Res.string.label_medium: StringResource
  get() = CommonMainString0.label_medium

private fun init_label_medium(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:label_medium", "label_medium",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    10528, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6152, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6688, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6692, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    10544, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5928, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6116, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6536, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6244, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    6388, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6404, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8560, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5916, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    7164, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5096, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6904, 28),
    )
)

internal val Res.string.label_merger_pass_limit: StringResource
  get() = CommonMainString0.label_merger_pass_limit

private fun init_label_merger_pass_limit(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_merger_pass_limit", "label_merger_pass_limit",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    10573, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6181, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6717, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6721, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    10585, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    5957, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6145, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6565, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6273, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    6421, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6433, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8601, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    5945, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    7201, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5125, 55),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6933, 55),
    )
)

internal val Res.string.label_no_saved_data: StringResource
  get() = CommonMainString0.label_no_saved_data

private fun init_label_no_saved_data(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_no_saved_data", "label_no_saved_data",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    10665, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6253, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6785, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6789, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    10665, 119),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6025, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6209, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6621, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6333, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    6481, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6505, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8689, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    6013, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    7277, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5181, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    6989, 47),
    )
)

internal val Res.string.label_no_saved_universes: StringResource
  get() = CommonMainString0.label_no_saved_universes

private fun init_label_no_saved_universes(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_no_saved_universes", "label_no_saved_universes",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    10773, 168),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6317, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6841, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6853, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    10785, 152),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6085, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6265, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6705, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6397, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    6541, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6557, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8773, 116),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    6065, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    7349, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5233, 64),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7037, 64),
    )
)

internal val Res.string.label_photosensitivity_short: StringResource
  get() = CommonMainString0.label_photosensitivity_short

private fun init_label_photosensitivity_short(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_photosensitivity_short", "label_photosensitivity_short",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    10942, 264),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6402, 164),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    6926, 172),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    6930, 188),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    10938, 308),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6154, 156),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6342, 156),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6798, 196),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6474, 180),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    6630, 160),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6634, 160),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    8890, 316),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    6130, 172),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    7434, 192),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5298, 128),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7102, 156),
    )
)

internal val Res.string.label_placement_mode: StringResource
  get() = CommonMainString0.label_placement_mode

private fun init_label_placement_mode(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_placement_mode", "label_placement_mode",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    11207, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6567, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7099, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7119, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    11247, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6311, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6499, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    6995, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6655, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    6791, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6795, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9207, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    6303, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    7627, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5427, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7259, 48),
    )
)

internal val Res.string.label_rewind_confirm: StringResource
  get() = CommonMainString0.label_rewind_confirm

private fun init_label_rewind_confirm(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_rewind_confirm", "label_rewind_confirm",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    11292, 416),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6620, 184),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7156, 168),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7172, 172),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    11328, 344),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6360, 164),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6560, 184),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    7044, 156),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6704, 160),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    6844, 156),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    6856, 168),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9280, 268),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    6356, 168),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    7696, 224),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5472, 120),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7308, 168),
    )
)

internal val Res.string.label_show_performance: StringResource
  get() = CommonMainString0.label_show_performance

private fun init_label_show_performance(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_show_performance", "label_show_performance",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    11709, 122),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6805, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7325, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7345, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    11673, 106),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6525, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6745, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    7201, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6865, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7001, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7025, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9549, 122),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    6525, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    7921, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5593, 54),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7477, 62),
    )
)

internal val Res.string.label_stark: StringResource
  get() = CommonMainString0.label_stark

private fun init_label_stark(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:label_stark", "label_stark",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    11832, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6872, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7396, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7428, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    11780, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6592, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6816, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    7288, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6928, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7068, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7096, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9672, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    6592, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8000, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5648, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7540, 27),
    )
)

internal val Res.string.label_stars_consume_planets: StringResource
  get() = CommonMainString0.label_stars_consume_planets

private fun init_label_stars_consume_planets(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_stars_consume_planets", "label_stars_consume_planets",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    11872, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6900, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7424, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7456, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    11820, 135),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6620, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6844, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    7316, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    6956, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7096, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7124, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9712, 99),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    6620, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8036, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5676, 59),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7568, 63),
    )
)

internal val Res.string.label_stars_dynamic: StringResource
  get() = CommonMainString0.label_stars_dynamic

private fun init_label_stars_dynamic(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_stars_dynamic", "label_stars_dynamic",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    11980, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    6976, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7496, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7540, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    11956, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6688, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6920, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    7388, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7024, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7172, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7196, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9812, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    6700, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8108, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5736, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7632, 51),
    )
)

internal val Res.string.label_stars_merge: StringResource
  get() = CommonMainString0.label_stars_merge

private fun init_label_stars_merge(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_stars_merge", "label_stars_merge",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    12068, 113),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7032, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7564, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7608, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    12040, 137),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6748, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    6980, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    7460, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7088, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7232, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7256, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    9892, 109),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    6760, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8164, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5780, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7684, 57),
    )
)

internal val Res.string.label_surface_view: StringResource
  get() = CommonMainString0.label_surface_view

private fun init_label_surface_view(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_surface_view", "label_surface_view",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    12182, 94),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7102, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7634, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7694, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    12178, 82),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6818, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7050, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    7530, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7146, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7306, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7322, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10002, 86),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    6834, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8230, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5834, 58),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7742, 58),
    )
)

internal val Res.string.label_technosignatures_detected: StringResource
  get() = CommonMainString0.label_technosignatures_detected

private fun init_label_technosignatures_detected(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:label_technosignatures_detected", "label_technosignatures_detected",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    12277, 143),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7165, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7693, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7757, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    12261, 115),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6881, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7109, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    7593, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7201, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7369, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7385, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10089, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    6893, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8297, 95),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5893, 67),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7801, 75),
    )
)

internal val Res.string.mode_crazy_eddie: StringResource
  get() = CommonMainString0.mode_crazy_eddie

private fun init_mode_crazy_eddie(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:mode_crazy_eddie", "mode_crazy_eddie",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    12421, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7237, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7765, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7837, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    12377, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6957, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7177, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    7677, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7285, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7441, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7461, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10197, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    6973, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8393, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    5961, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7877, 40),
    )
)

internal val Res.string.mode_dual_star: StringResource
  get() = CommonMainString0.mode_dual_star

private fun init_mode_dual_star(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mode_dual_star", "mode_dual_star",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    12486, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7278, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7806, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7878, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    12446, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    6998, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7218, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    7738, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7338, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7486, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7502, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10258, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    7018, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8434, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6002, 30),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7918, 34),
    )
)

internal val Res.string.mode_move: StringResource
  get() = CommonMainString0.mode_move

private fun init_mode_move(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mode_move", "mode_move",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7953, 25),
    )
)

internal val Res.string.mode_rain: StringResource
  get() = CommonMainString0.mode_rain

private fun init_mode_rain(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mode_rain", "mode_rain",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    7979, 25),
    )
)

internal val Res.string.mode_single_star: StringResource
  get() = CommonMainString0.mode_single_star

private fun init_mode_single_star(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:mode_single_star", "mode_single_star",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    12549, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7317, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7849, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7921, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    12509, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    7041, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7261, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    7789, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7369, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7533, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7549, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10317, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    7061, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8469, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6033, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    8005, 40),
    )
)

internal val Res.string.mode_slingshot: StringResource
  get() = CommonMainString0.mode_slingshot

private fun init_mode_slingshot(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:mode_slingshot", "mode_slingshot",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    8046, 34),
    )
)

internal val Res.string.msg_fullscreen_hint: StringResource
  get() = CommonMainString0.msg_fullscreen_hint

private fun init_msg_fullscreen_hint(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:msg_fullscreen_hint", "msg_fullscreen_hint",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    8081, 67),
    )
)

internal val Res.string.msg_jordy_extinction: StringResource
  get() = CommonMainString0.msg_jordy_extinction

private fun init_msg_jordy_extinction(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:msg_jordy_extinction", "msg_jordy_extinction",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    12606, 260),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7358, 148),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    7894, 132),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    7966, 144),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    12566, 236),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    7086, 124),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7306, 136),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    7842, 184),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7406, 160),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7582, 124),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7594, 128),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10386, 184),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    7102, 116),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8506, 160),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6066, 128),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    8149, 124),
    )
)

internal val Res.string.msg_web_upsell: StringResource
  get() = CommonMainString0.msg_web_upsell

private fun init_msg_web_upsell(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:msg_web_upsell", "msg_web_upsell",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    8274, 202),
    )
)

internal val Res.string.name_debris: StringResource
  get() = CommonMainString0.name_debris

private fun init_name_debris(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:name_debris", "name_debris",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    12867, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7507, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8027, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8111, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    12803, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    7211, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7443, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    8027, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7567, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7707, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7723, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10571, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    7219, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8667, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6195, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    8477, 27),
    )
)

internal val Res.string.name_fragment: StringResource
  get() = CommonMainString0.name_fragment

private fun init_name_fragment(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:name_fragment", "name_fragment",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    12927, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7539, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8055, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8143, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    12839, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    7239, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7475, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    8059, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7599, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7735, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7759, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10611, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    7247, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8703, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6223, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    8505, 33),
    )
)

internal val Res.string.name_nebula: StringResource
  get() = CommonMainString0.name_nebula

private fun init_name_nebula(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:name_nebula", "name_nebula",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    12969, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7573, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8089, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8177, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    12885, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    7273, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7509, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    8089, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7629, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7769, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7793, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10657, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    7277, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8741, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6253, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    8539, 27),
    )
)

internal val Res.string.name_planet: StringResource
  get() = CommonMainString0.name_planet

private fun init_name_planet(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:name_planet", "name_planet",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    13021, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7601, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8121, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8213, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    12937, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    7301, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7541, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    8117, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7657, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7801, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7825, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10705, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    7309, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8773, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6281, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    8567, 27),
    )
)

internal val Res.string.name_proto_star: StringResource
  get() = CommonMainString0.name_proto_star

private fun init_name_proto_star(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:name_proto_star", "name_proto_star",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    13057, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7629, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8153, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8245, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    12973, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    7329, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7573, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    8145, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7685, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7833, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7857, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10745, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    7341, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8809, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6309, 35),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    8595, 39),
    )
)

internal val Res.string.name_singularity: StringResource
  get() = CommonMainString0.name_singularity

private fun init_name_singularity(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:name_singularity", "name_singularity",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    13129, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7669, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8197, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8289, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    13041, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    7373, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7613, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    8181, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7721, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7877, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7897, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10801, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    7381, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8857, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6345, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    8635, 40),
    )
)

internal val Res.string.obs_desc_camera: StringResource
  get() = CommonMainString0.obs_desc_camera

private fun init_obs_desc_camera(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:obs_desc_camera", "obs_desc_camera",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    13198, 435),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7714, 211),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8238, 383),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8330, 283),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    13102, 427),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    7414, 239),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7654, 259),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    8218, 227),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7758, 231),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    7918, 211),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    7942, 251),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    10862, 335),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    7418, 195),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    8906, 319),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6378, 199),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    8676, 343),
    )
)

internal val Res.string.obs_desc_farrell: StringResource
  get() = CommonMainString0.obs_desc_farrell

private fun init_obs_desc_farrell(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:obs_desc_farrell", "obs_desc_farrell",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    13634, 556),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    7926, 280),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    8622, 468),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8614, 260),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    13530, 568),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    7654, 244),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    7914, 248),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    8446, 272),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    7990, 276),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    8130, 276),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8194, 252),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11198, 424),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    7614, 320),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    9226, 320),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6578, 268),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    9020, 1204),
    )
)

internal val Res.string.obs_desc_fast_travel: StringResource
  get() = CommonMainString0.obs_desc_fast_travel

private fun init_obs_desc_fast_travel(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:obs_desc_fast_travel", "obs_desc_fast_travel",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    14191, 468),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8207, 252),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9091, 264),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    8875, 280),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    14099, 512),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    7899, 232),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    8163, 248),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    8719, 280),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    8267, 248),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    8407, 236),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8447, 232),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11623, 356),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    7935, 244),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    9547, 304),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    6847, 200),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    10225, 348),
    )
)

internal val Res.string.obs_desc_oracle: StringResource
  get() = CommonMainString0.obs_desc_oracle

private fun init_obs_desc_oracle(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:obs_desc_oracle", "obs_desc_oracle",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    14660, 355),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8460, 227),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9356, 439),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9156, 283),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    14612, 355),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    8132, 235),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    8412, 295),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    9000, 219),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    8516, 195),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    8644, 195),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8680, 255),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    11980, 343),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    8180, 247),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    9852, 307),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7048, 203),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    10574, 471),
    )
)

internal val Res.string.obs_desc_scanner: StringResource
  get() = CommonMainString0.obs_desc_scanner

private fun init_obs_desc_scanner(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:obs_desc_scanner", "obs_desc_scanner",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    15016, 416),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8688, 208),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    9796, 304),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9440, 272),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    14968, 388),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    8368, 200),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    8708, 232),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    9220, 224),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    8712, 236),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    8840, 212),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    8936, 232),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12324, 288),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    8428, 212),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    10160, 272),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7252, 168),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    11046, 256),
    )
)

internal val Res.string.obs_title_camera: StringResource
  get() = CommonMainString0.obs_title_camera

private fun init_obs_title_camera(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:obs_title_camera", "obs_title_camera",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    15433, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8897, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10101, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9713, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    15357, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    8569, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    8941, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    9445, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    8949, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    9053, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9169, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12613, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    8641, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    10433, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7421, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    11303, 48),
    )
)

internal val Res.string.obs_title_farrell: StringResource
  get() = CommonMainString0.obs_title_farrell

private fun init_obs_title_farrell(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:obs_title_farrell", "obs_title_farrell",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    15506, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    8950, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10162, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9766, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    15422, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    8614, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    9006, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    9490, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    8998, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    9102, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9230, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12678, 97),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    8686, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    10482, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7462, 57),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    11352, 57),
    )
)

internal val Res.string.obs_title_fast_travel: StringResource
  get() = CommonMainString0.obs_title_fast_travel

private fun init_obs_title_fast_travel(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:obs_title_fast_travel", "obs_title_fast_travel",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    15608, 125),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9012, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10224, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9828, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    15512, 117),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    8676, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    9072, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    9556, 89),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    9056, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    9164, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9292, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12776, 121),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    8744, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    10560, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7520, 57),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    11410, 61),
    )
)

internal val Res.string.obs_title_oracle: StringResource
  get() = CommonMainString0.obs_title_oracle

private fun init_obs_title_oracle(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:obs_title_oracle", "obs_title_oracle",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    15734, 116),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9074, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10302, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9906, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    15630, 104),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    8746, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    9154, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    9646, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    9126, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    9238, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9370, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12898, 88),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    8814, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    10642, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7578, 52),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    11472, 60),
    )
)

internal val Res.string.obs_title_scanner: StringResource
  get() = CommonMainString0.obs_title_scanner

private fun init_obs_title_scanner(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:obs_title_scanner", "obs_title_scanner",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    15851, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9135, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10367, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    9967, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    15735, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    8815, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    9219, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    9711, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    9187, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    9311, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9435, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    12987, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    8875, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    10715, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7631, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    11533, 49),
    )
)

internal val Res.string.path_desc_chaos: StringResource
  get() = CommonMainString0.path_desc_chaos

private fun init_path_desc_chaos(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:path_desc_chaos", "path_desc_chaos",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    15937, 1075),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9189, 543),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10421, 555),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10021, 499),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    15817, 1031),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    8861, 463),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    9269, 515),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    9781, 659),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    9241, 551),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    9361, 559),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9489, 467),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13061, 863),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    8925, 499),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    10769, 647),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    7677, 439),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    11583, 507),
    )
)

internal val Res.string.path_title_chaos: StringResource
  get() = CommonMainString0.path_title_chaos

private fun init_path_title_chaos(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:path_title_chaos", "path_title_chaos",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    17013, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9733, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    10977, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10521, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    16849, 108),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    9325, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    9785, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    10441, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    9793, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    9921, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    9957, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13925, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    9425, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    11417, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8117, 40),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    12091, 48),
    )
)

internal val Res.string.phen_desc_evolution: StringResource
  get() = CommonMainString0.phen_desc_evolution

private fun init_phen_desc_evolution(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phen_desc_evolution", "phen_desc_evolution",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    17094, 415),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    9778, 263),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11030, 419),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10570, 319),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    16958, 483),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    9370, 259),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    9838, 279),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    10494, 307),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    9842, 283),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    9966, 211),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10006, 291),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    13974, 383),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    9470, 243),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    11474, 355),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8158, 235),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    12140, 851),
    )
)

internal val Res.string.phen_desc_jordys: StringResource
  get() = CommonMainString0.phen_desc_jordys

private fun init_phen_desc_jordys(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phen_desc_jordys", "phen_desc_jordys",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    17510, 600),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10042, 312),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11450, 360),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    10890, 272),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    17442, 632),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    9630, 212),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    10118, 248),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    10802, 320),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    10126, 284),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    10178, 224),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10298, 260),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14358, 400),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    9714, 264),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    11830, 292),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8394, 260),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    12992, 948),
    )
)

internal val Res.string.phen_desc_nebulae: StringResource
  get() = CommonMainString0.phen_desc_nebulae

private fun init_phen_desc_nebulae(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phen_desc_nebulae", "phen_desc_nebulae",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    18111, 369),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10355, 189),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    11811, 297),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11163, 209),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    18075, 369),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    9843, 181),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    10367, 181),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    11123, 205),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    10411, 213),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    10403, 173),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10559, 177),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    14759, 297),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    9979, 173),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    12123, 225),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8655, 161),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    13941, 277),
    )
)

internal val Res.string.phen_desc_wormholes: StringResource
  get() = CommonMainString0.phen_desc_wormholes

private fun init_phen_desc_wormholes(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phen_desc_wormholes", "phen_desc_wormholes",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    14219, 131),
    )
)

internal val Res.string.phen_title_evolution: StringResource
  get() = CommonMainString0.phen_title_evolution

private fun init_phen_title_evolution(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phen_title_evolution", "phen_title_evolution",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    18481, 96),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10545, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    12109, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11373, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    18445, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    10025, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    10549, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    11329, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    10625, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    10577, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10737, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15057, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    10153, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    12349, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8817, 44),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    14351, 56),
    )
)

internal val Res.string.phen_title_jordys: StringResource
  get() = CommonMainString0.phen_title_jordys

private fun init_phen_title_jordys(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phen_title_jordys", "phen_title_jordys",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    18578, 137),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10606, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    12166, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11430, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    18522, 137),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    10082, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    10602, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    11374, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    10674, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    10642, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10794, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15142, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    10202, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    12406, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8862, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    14408, 69),
    )
)

internal val Res.string.phen_title_nebulae: StringResource
  get() = CommonMainString0.phen_title_nebulae

private fun init_phen_title_nebulae(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phen_title_nebulae", "phen_title_nebulae",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    18716, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10672, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    12236, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11500, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    18660, 98),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    10148, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    10672, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    11444, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    10736, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    10716, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10864, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15228, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    10264, 38),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    12480, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8916, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    14478, 46),
    )
)

internal val Res.string.phen_title_wormholes: StringResource
  get() = CommonMainString0.phen_title_wormholes

private fun init_phen_title_wormholes(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phen_title_wormholes", "phen_title_wormholes",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    14525, 72),
    )
)

internal val Res.string.phys_desc_barycenter: StringResource
  get() = CommonMainString0.phys_desc_barycenter

private fun init_phys_desc_barycenter(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phys_desc_barycenter", "phys_desc_barycenter",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    18783, 460),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10715, 196),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    12287, 276),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11555, 220),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    18759, 444),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    10191, 240),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    10723, 232),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    11479, 204),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    10783, 240),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    10771, 192),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    10915, 228),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15283, 276),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    10303, 208),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    12527, 240),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    8959, 172),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    14598, 364),
    )
)

internal val Res.string.phys_desc_gscaling: StringResource
  get() = CommonMainString0.phys_desc_gscaling

private fun init_phys_desc_gscaling(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phys_desc_gscaling", "phys_desc_gscaling",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    19244, 350),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    10912, 158),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    12564, 254),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11776, 206),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    19204, 370),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    10432, 174),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    10956, 202),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    11684, 234),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    11024, 194),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    10964, 166),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11144, 206),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15560, 290),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    10512, 158),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    12768, 206),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9132, 158),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    14963, 318),
    )
)

internal val Res.string.phys_desc_science: StringResource
  get() = CommonMainString0.phys_desc_science

private fun init_phys_desc_science(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phys_desc_science", "phys_desc_science",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    19595, 425),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11071, 205),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    12819, 245),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    11983, 253),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    19575, 469),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    10607, 209),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    11159, 237),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    11919, 245),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    11219, 233),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    11131, 169),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11351, 213),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    15851, 305),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    10671, 193),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    12975, 249),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9291, 157),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    15282, 313),
    )
)

internal val Res.string.phys_desc_tweaks: StringResource
  get() = CommonMainString0.phys_desc_tweaks

private fun init_phys_desc_tweaks(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phys_desc_tweaks", "phys_desc_tweaks",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    20021, 440),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11277, 176),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    13065, 208),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    12237, 212),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    20045, 532),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    10817, 224),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    11397, 216),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    12165, 212),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    11453, 240),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    11301, 196),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11565, 220),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    16157, 324),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    10865, 204),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    13225, 268),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9449, 172),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    15596, 364),
    )
)

internal val Res.string.phys_desc_wells: StringResource
  get() = CommonMainString0.phys_desc_wells

private fun init_phys_desc_wells(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:phys_desc_wells", "phys_desc_wells",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    20462, 435),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11454, 195),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    13274, 287),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    12450, 251),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    20578, 443),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    11042, 207),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    11614, 235),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    12378, 179),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    11694, 199),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    11498, 195),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    11786, 223),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    16482, 287),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    11070, 203),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    13494, 235),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9622, 175),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    15961, 339),
    )
)

internal val Res.string.phys_title_barycenter: StringResource
  get() = CommonMainString0.phys_title_barycenter

private fun init_phys_title_barycenter(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phys_title_barycenter", "phys_title_barycenter",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    20898, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11650, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    13562, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    12702, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    21022, 129),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    11250, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    11850, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    12558, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    11894, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    11694, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    12010, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    16770, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    11274, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    13730, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9798, 45),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    16301, 57),
    )
)

internal val Res.string.phys_title_gscaling: StringResource
  get() = CommonMainString0.phys_title_gscaling

private fun init_phys_title_gscaling(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phys_title_gscaling", "phys_title_gscaling",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    21004, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11712, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    13628, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    12768, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    21152, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    11304, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    11916, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    12636, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    11956, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    11752, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    12072, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    16844, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    11340, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    13792, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9844, 51),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    16359, 55),
    )
)

internal val Res.string.phys_title_science: StringResource
  get() = CommonMainString0.phys_title_science

private fun init_phys_title_science(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phys_title_science", "phys_title_science",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    21112, 118),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11776, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    13692, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    12848, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    21260, 122),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    11360, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    11984, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    12724, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    12016, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    11816, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    12144, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    16936, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    11400, 46),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    13868, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9896, 42),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    16415, 50),
    )
)

internal val Res.string.phys_title_tweaks: StringResource
  get() = CommonMainString0.phys_title_tweaks

private fun init_phys_title_tweaks(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phys_title_tweaks", "phys_title_tweaks",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    21231, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11827, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    13751, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    12895, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    21383, 93),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    11411, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    12031, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    12783, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    12071, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    11863, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    12191, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    16999, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    11447, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    13927, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9939, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    16466, 45),
    )
)

internal val Res.string.phys_title_wells: StringResource
  get() = CommonMainString0.phys_title_wells

private fun init_phys_title_wells(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:phys_title_wells", "phys_title_wells",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    21337, 120),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11881, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    13805, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    12953, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    21477, 140),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    11461, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    12081, 64),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    12849, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    12133, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    11921, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    12241, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    17069, 84),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    11505, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    13981, 72),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    9981, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    16512, 60),
    )
)

internal val Res.string.qs_desc_canvas: StringResource
  get() = CommonMainString0.qs_desc_canvas

private fun init_qs_desc_canvas(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:qs_desc_canvas", "qs_desc_canvas",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    21458, 238),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    11930, 122),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    13870, 138),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    13022, 142),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    21618, 214),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    11522, 118),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    12146, 130),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    12910, 174),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    12202, 142),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    11974, 142),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    12310, 126),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    17154, 178),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    11562, 114),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    14054, 146),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10030, 102),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    16573, 114),
    )
)

internal val Res.string.qs_desc_inspect: StringResource
  get() = CommonMainString0.qs_desc_inspect

private fun init_qs_desc_inspect(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:qs_desc_inspect", "qs_desc_inspect",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    21697, 315),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    12053, 195),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    14009, 191),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    13165, 211),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    21833, 407),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    11641, 171),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    12277, 195),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    13085, 211),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    12345, 183),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    12117, 215),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    12437, 187),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    17333, 327),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    11677, 171),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    14201, 251),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10133, 143),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    16688, 155),
    )
)

internal val Res.string.qs_desc_rain: StringResource
  get() = CommonMainString0.qs_desc_rain

private fun init_qs_desc_rain(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:qs_desc_rain", "qs_desc_rain",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    22013, 452),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    12249, 216),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    14201, 292),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    13377, 324),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    22241, 560),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    11813, 292),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    12473, 276),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    13297, 244),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    12529, 248),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    12333, 280),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    12625, 272),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    17661, 408),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    11849, 204),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    14453, 356),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10277, 192),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    16844, 336),
    )
)

internal val Res.string.qs_desc_yeet: StringResource
  get() = CommonMainString0.qs_desc_yeet

private fun init_qs_desc_yeet(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:qs_desc_yeet", "qs_desc_yeet",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    22466, 388),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    12466, 264),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    14494, 308),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    13702, 384),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    22802, 572),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12106, 336),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    12750, 308),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    13542, 276),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    12778, 324),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    12614, 356),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    12898, 348),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    18070, 504),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12054, 268),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    14810, 380),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10470, 236),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17181, 300),
    )
)

internal val Res.string.qs_title_canvas: StringResource
  get() = CommonMainString0.qs_title_canvas

private fun init_qs_title_canvas(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:qs_title_canvas", "qs_title_canvas",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    22855, 119),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    12731, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    14803, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14087, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    23375, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12443, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13059, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    13819, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13103, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    12971, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13247, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    18575, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12323, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15191, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10707, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17482, 51),
    )
)

internal val Res.string.qs_title_inspect: StringResource
  get() = CommonMainString0.qs_title_inspect

private fun init_qs_title_inspect(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:qs_title_inspect", "qs_title_inspect",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    22975, 104),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    12795, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    14851, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14147, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    23467, 92),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12495, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13107, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    13879, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13155, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13023, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13299, 56),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    18639, 76),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12375, 52),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15247, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10751, 48),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17534, 52),
    )
)

internal val Res.string.qs_title_rain: StringResource
  get() = CommonMainString0.qs_title_rain

private fun init_qs_title_rain(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:qs_title_rain", "qs_title_rain",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23080, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    12856, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    14908, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14204, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    23560, 85),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12548, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13164, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    13928, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13208, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13080, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13356, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    18716, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12428, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15316, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10800, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17587, 57),
    )
)

internal val Res.string.qs_title_yeet: StringResource
  get() = CommonMainString0.qs_title_yeet

private fun init_qs_title_yeet(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:qs_title_yeet", "qs_title_yeet",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23138, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    12922, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    14970, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14266, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    23646, 101),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12606, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13222, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    13986, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13262, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13134, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13414, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    18786, 81),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12498, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15386, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10854, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17645, 57),
    )
)

internal val Res.string.stat_bh: StringResource
  get() = CommonMainString0.stat_bh

private fun init_stat_bh(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:stat_bh", "stat_bh",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23244, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    12988, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15028, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14328, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    23748, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12664, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13280, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14048, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13316, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13192, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13472, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    18868, 23),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12556, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15444, 19),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10908, 23),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17703, 19),
    )
)

internal val Res.string.stat_fps: StringResource
  get() = CommonMainString0.stat_fps

private fun init_stat_fps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:stat_fps", "stat_fps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23280, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13008, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15048, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14348, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    23768, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12684, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13300, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14068, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13344, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13212, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13492, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    18892, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12576, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15464, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10932, 20),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17723, 20),
    )
)

internal val Res.string.stat_heaviest: StringResource
  get() = CommonMainString0.stat_heaviest

private fun init_stat_heaviest(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:stat_heaviest", "stat_heaviest",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23301, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13029, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15069, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14369, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    23789, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12705, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13321, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14089, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13365, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13233, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13513, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    18913, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12597, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15485, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10953, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17744, 33),
    )
)

internal val Res.string.stat_planets: StringResource
  get() = CommonMainString0.stat_planets

private fun init_stat_planets(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:stat_planets", "stat_planets",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23347, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13067, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15107, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14407, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    23847, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12739, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13359, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14127, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13407, 28),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13271, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13551, 32),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    18971, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12631, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15527, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    10983, 28),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17778, 32),
    )
)

internal val Res.string.stat_speed: StringResource
  get() = CommonMainString0.stat_speed

private fun init_stat_speed(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:stat_speed", "stat_speed",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23384, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13100, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15140, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14440, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    23884, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12768, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13392, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14156, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13436, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13304, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13584, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    19012, 42),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12668, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15564, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11012, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17811, 26),
    )
)

internal val Res.string.stat_stars: StringResource
  get() = CommonMainString0.stat_stars

private fun init_stat_stars(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:stat_stars", "stat_stars",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23415, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13131, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15171, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14471, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    23915, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12799, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13423, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14183, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13463, 26),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13339, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13619, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    19055, 34),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12691, 30),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15599, 22),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11039, 26),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17838, 26),
    )
)

internal val Res.string.stat_system: StringResource
  get() = CommonMainString0.stat_system

private fun init_stat_system(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:stat_system", "stat_system",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23450, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13158, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15202, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14502, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    23950, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12830, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13450, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14210, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13490, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13370, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13650, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    19090, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12722, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15622, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11066, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17865, 27),
    )
)

internal val Res.string.stat_tps: StringResource
  get() = CommonMainString0.stat_tps

private fun init_stat_tps(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:stat_tps", "stat_tps",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23498, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13186, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15234, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14534, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    23998, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12858, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13482, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14242, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13530, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13398, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13682, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    19130, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12754, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15658, 20),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11098, 20),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17893, 20),
    )
)

internal val Res.string.tab_chemicals: StringResource
  get() = CommonMainString0.tab_chemicals

private fun init_tab_chemicals(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tab_chemicals", "tab_chemicals",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23519, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13207, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15255, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14555, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    24019, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12879, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13503, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14263, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13551, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13419, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13703, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    19151, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12775, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15679, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11119, 37),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17914, 33),
    )
)

internal val Res.string.tab_scanner: StringResource
  get() = CommonMainString0.tab_scanner

private fun init_tab_scanner(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tab_scanner", "tab_scanner",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23577, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13237, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15289, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14589, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    24061, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12909, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13537, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14301, 39),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13593, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13449, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13737, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    19189, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12813, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15717, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11157, 31),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17948, 31),
    )
)

internal val Res.string.title_advanced_config: StringResource
  get() = CommonMainString0.title_advanced_config

private fun init_title_advanced_config(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:title_advanced_config", "title_advanced_config",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23633, 129),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13269, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15321, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14621, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    24105, 129),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    12941, 65),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13569, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14341, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13625, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13477, 77),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13769, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    19225, 105),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12845, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15753, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11189, 53),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    17980, 61),
    )
)

internal val Res.string.title_changelog: StringResource
  get() = CommonMainString0.title_changelog

private fun init_title_changelog(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:title_changelog", "title_changelog",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    18042, 51),
    )
)

internal val Res.string.title_photosensitivity: StringResource
  get() = CommonMainString0.title_photosensitivity

private fun init_title_photosensitivity(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:title_photosensitivity", "title_photosensitivity",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23763, 122),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13347, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15395, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14695, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    24235, 130),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    13007, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13643, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14399, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13683, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13555, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13843, 66),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    19331, 126),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12919, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15827, 78),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11243, 50),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    18094, 62),
    )
)

internal val Res.string.title_rewind_dialog: StringResource
  get() = CommonMainString0.title_rewind_dialog

private fun init_title_rewind_dialog(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:title_rewind_dialog", "title_rewind_dialog",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23886, 87),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13418, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15470, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14774, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    24366, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    13074, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13710, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14470, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13742, 75),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13626, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13910, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    19458, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    12994, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15906, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11294, 47),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    18157, 51),
    )
)

internal val Res.string.title_save_universe: StringResource
  get() = CommonMainString0.title_save_universe

private fun init_title_save_universe(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:title_save_universe", "title_save_universe",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    23974, 107),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13486, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15530, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14830, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    24458, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    13142, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13774, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14542, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13818, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13686, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    13962, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    19538, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    13050, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    15966, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11342, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    18209, 47),
    )
)

internal val Res.string.title_universe_browser: StringResource
  get() = CommonMainString0.title_universe_browser

private fun init_title_universe_browser(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:title_universe_browser", "title_universe_browser",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    24082, 102),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13542, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15582, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14890, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    24550, 102),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    13190, 50),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13822, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14590, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13866, 58),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13742, 70),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    14010, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    19618, 74),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    13098, 54),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    16014, 62),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11386, 50),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    18257, 54),
    )
)

internal val Res.string.title_web_upsell: StringResource
  get() = CommonMainString0.title_web_upsell

private fun init_title_web_upsell(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:title_web_upsell", "title_web_upsell",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    18312, 48),
    )
)

internal val Res.string.tm_desc_dilation: StringResource
  get() = CommonMainString0.tm_desc_dilation

private fun init_tm_desc_dilation(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tm_desc_dilation", "tm_desc_dilation",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    24185, 368),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13597, 184),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15645, 304),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    14949, 308),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    24653, 404),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    13241, 268),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    13877, 288),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14645, 248),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    13925, 272),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    13813, 276),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    14073, 256),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    19693, 208),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    13153, 168),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    16077, 352),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11437, 192),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    18361, 264),
    )
)

internal val Res.string.tm_desc_rewind: StringResource
  get() = CommonMainString0.tm_desc_rewind

private fun init_tm_desc_rewind(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tm_desc_rewind", "tm_desc_rewind",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    24554, 390),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    13782, 230),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    15950, 314),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    15258, 354),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    25058, 422),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    13510, 290),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    14166, 246),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    14894, 330),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    14198, 314),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    14090, 270),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    14330, 262),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    19902, 314),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    13322, 198),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    16430, 330),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11630, 206),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    18626, 306),
    )
)

internal val Res.string.tm_title_dilation: StringResource
  get() = CommonMainString0.tm_title_dilation

private fun init_tm_title_dilation(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tm_title_dilation", "tm_title_dilation",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    24945, 73),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    14013, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    16265, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    15613, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    25481, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    13801, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    14413, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    15225, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    14513, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    14361, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    14593, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    20217, 69),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    13521, 49),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    16761, 57),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11837, 41),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    18933, 45),
    )
)

internal val Res.string.tm_title_rewind: StringResource
  get() = CommonMainString0.tm_title_rewind

private fun init_tm_title_rewind(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tm_title_rewind", "tm_title_rewind",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    25019, 103),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    14059, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    16323, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    15667, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    25551, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    13847, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    14467, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    15271, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    14559, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    14407, 55),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    14647, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    20287, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    13571, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    16819, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11879, 39),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    18979, 47),
    )
)

internal val Res.string.tutorial_btn_finish: StringResource
  get() = CommonMainString0.tutorial_btn_finish

private fun init_tutorial_btn_finish(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_btn_finish", "tutorial_btn_finish",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    19027, 47),
    )
)

internal val Res.string.tutorial_btn_next: StringResource
  get() = CommonMainString0.tutorial_btn_next

private fun init_tutorial_btn_next(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_btn_next", "tutorial_btn_next",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    19075, 37),
    )
)

internal val Res.string.tutorial_btn_skip: StringResource
  get() = CommonMainString0.tutorial_btn_skip

private fun init_tutorial_btn_skip(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_btn_skip", "tutorial_btn_skip",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    19113, 41),
    )
)

internal val Res.string.tutorial_step1_desc: StringResource
  get() = CommonMainString0.tutorial_step1_desc

private fun init_tutorial_step1_desc(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_step1_desc", "tutorial_step1_desc",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    19331, 139),
    )
)

internal val Res.string.tutorial_step1_desc_web: StringResource
  get() = CommonMainString0.tutorial_step1_desc_web

private fun init_tutorial_step1_desc_web(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_step1_desc_web", "tutorial_step1_desc_web",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    19155, 175),
    )
)

internal val Res.string.tutorial_step1_title: StringResource
  get() = CommonMainString0.tutorial_step1_title

private fun init_tutorial_step1_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_step1_title", "tutorial_step1_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    19471, 60),
    )
)

internal val Res.string.tutorial_step2_desc: StringResource
  get() = CommonMainString0.tutorial_step2_desc

private fun init_tutorial_step2_desc(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_step2_desc", "tutorial_step2_desc",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    19532, 219),
    )
)

internal val Res.string.tutorial_step2_title: StringResource
  get() = CommonMainString0.tutorial_step2_title

private fun init_tutorial_step2_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_step2_title", "tutorial_step2_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    19752, 68),
    )
)

internal val Res.string.tutorial_step3_desc: StringResource
  get() = CommonMainString0.tutorial_step3_desc

private fun init_tutorial_step3_desc(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_step3_desc", "tutorial_step3_desc",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    19821, 223),
    )
)

internal val Res.string.tutorial_step3_title: StringResource
  get() = CommonMainString0.tutorial_step3_title

private fun init_tutorial_step3_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_step3_title", "tutorial_step3_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    20045, 64),
    )
)

internal val Res.string.tutorial_step4_desc: StringResource
  get() = CommonMainString0.tutorial_step4_desc

private fun init_tutorial_step4_desc(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_step4_desc", "tutorial_step4_desc",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    20110, 215),
    )
)

internal val Res.string.tutorial_step4_title: StringResource
  get() = CommonMainString0.tutorial_step4_title

private fun init_tutorial_step4_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_step4_title", "tutorial_step4_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    20326, 80),
    )
)

internal val Res.string.tutorial_step5_desc: StringResource
  get() = CommonMainString0.tutorial_step5_desc

private fun init_tutorial_step5_desc(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_step5_desc", "tutorial_step5_desc",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    20407, 207),
    )
)

internal val Res.string.tutorial_step5_title: StringResource
  get() = CommonMainString0.tutorial_step5_title

private fun init_tutorial_step5_title(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:tutorial_step5_title", "tutorial_step5_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    20615, 60),
    )
)

internal val Res.string.tutorial_title: StringResource
  get() = CommonMainString0.tutorial_title

private fun init_tutorial_title(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:tutorial_title", "tutorial_title",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    20676, 50),
    )
)

internal val Res.string.type_nebula: StringResource
  get() = CommonMainString0.type_nebula

private fun init_type_nebula(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:type_nebula", "type_nebula",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    25123, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    14115, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    16375, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    15719, 35),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    25643, 63),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    13899, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    14527, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    15343, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    14607, 27),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    14463, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    14699, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    20371, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    13623, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    16879, 31),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11919, 27),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    20727, 27),
    )
)

internal val Res.string.type_planetary_body: StringResource
  get() = CommonMainString0.type_planetary_body

private fun init_type_planetary_body(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:type_planetary_body", "type_planetary_body",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    25175, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    14143, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    16407, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    15755, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    25707, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    13927, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    14559, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    15371, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    14635, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    14495, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    14731, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    20419, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    13655, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    16911, 59),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11947, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    20755, 47),
    )
)

internal val Res.string.type_singularity: StringResource
  get() = CommonMainString0.type_singularity

private fun init_type_singularity(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:type_singularity", "type_singularity",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    25255, 68),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    14195, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    16459, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    15807, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    25775, 80),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    13971, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    14611, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    15415, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    14683, 36),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    14547, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    14783, 44),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    20491, 60),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    13707, 40),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    16971, 48),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    11991, 32),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    20803, 40),
    )
)

internal val Res.string.type_star: StringResource
  get() = CommonMainString0.type_star

private fun init_type_star(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:type_star", "type_star",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    25324, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    14240, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    16500, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    15848, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    25856, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    14012, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    14652, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    15452, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    14720, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    14588, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    14828, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    20552, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    13748, 25),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    17020, 21),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    12024, 25),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    20844, 25),
    )
)

internal val Res.string.type_stellar_object: StringResource
  get() = CommonMainString0.type_stellar_object

private fun init_type_stellar_object(): StringResource =
    org.jetbrains.compose.resources.StringResource(
  "string:type_stellar_object", "type_stellar_object",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    25358, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    14266, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    16530, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    15878, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    25890, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    14042, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    14678, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    15478, 43),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    14746, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    14618, 51),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    14858, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    20586, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    13774, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    17042, 47),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    12050, 43),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    20870, 47),
    )
)

internal val Res.string.type_wormhole: StringResource
  get() = CommonMainString0.type_wormhole

private fun init_type_wormhole(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:type_wormhole", "type_wormhole",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    25450, 61),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    14318, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    16578, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    15926, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    25958, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    14090, 41),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    14730, 37),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    15522, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    14794, 29),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    14670, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    14906, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    20654, 53),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    13822, 45),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    17090, 33),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    12094, 29),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    20918, 33),
    )
)

internal val Res.string.version_edition: StringResource
  get() = CommonMainString0.version_edition

private fun init_version_edition(): StringResource = org.jetbrains.compose.resources.StringResource(
  "string:version_edition", "version_edition",
    setOf(
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("bn"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-bn/strings.commonMain.cvr",
    25512, 127),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("de"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-de/strings.commonMain.cvr",
    14352, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("es"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-es/strings.commonMain.cvr",
    16624, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("fr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-fr/strings.commonMain.cvr",
    15964, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("hi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-hi/strings.commonMain.cvr",
    26012, 111),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("id"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-id/strings.commonMain.cvr",
    14132, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("it"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-it/strings.commonMain.cvr",
    14768, 83),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ja"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ja/strings.commonMain.cvr",
    15568, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ko"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ko/strings.commonMain.cvr",
    14824, 71),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pl"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pl/strings.commonMain.cvr",
    14724, 67),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("pt"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-pt/strings.commonMain.cvr",
    14952, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("ru"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-ru/strings.commonMain.cvr",
    20708, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("tr"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-tr/strings.commonMain.cvr",
    13868, 79),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("vi"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-vi/strings.commonMain.cvr",
    17124, 91),
     
    org.jetbrains.compose.resources.ResourceItem(setOf(org.jetbrains.compose.resources.LanguageQualifier("zh"),
    ),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values-zh/strings.commonMain.cvr",
    12124, 63),
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/crashbit_multiplatform.composeapp.generated.resources/values/strings.commonMain.cvr",
    20952, 59),
    )
)
